
<div class="h-full mb-[50px]">
  @if(showHistory){
    <!-- Same shell as the order details history (quotes/components/quote-item-history.component.html):
         without the m-content / container-fixed / m-portlet__body wrappers the log list rendered
         edge to edge with no page padding, detached from the rest of the claim chrome. -->
    <div class="tab-content">
      <div class="tab-pane active m-scrollable">
        <div class="m-content">
          <div class="container-fixed">
            <div class="m-portlet__body m-portlet__body--no-padding">
              <div class="flex items-center justify-between mb-4">
                <button class="back-btn-history" (click)="hideHistory()">
                  <i class="fas fa-arrow-left"></i>
                  <span>Back</span>
                </button>
                <button
                  class="py-2 px-4 font-medium f-16"
                  style="border-radius: 6px; border: 1px solid var(--border-subtle)"
                  (click)="devView = !devView"
                  [ngClass]="{
                    'bg-blue-50 text-blue-800': devView,
                    'bg-white text-black': !devView
                  }"
                >
                  <i class="fa-solid fa-code" style="font-size: 14px"></i>
                </button>
              </div>
              <app-history-logs [resourceType]="'claims'" [devView]="devView" [resourceId]="$safeNavigationMigration(claim?._id)"></app-history-logs>
            </div>
          </div>
        </div>
      </div>
    </div>
  }@else {
    <div class="claim-details-header relative">
      @if(newDocument){
        <div class="modal" (click)="newDocument = false"></div>
      }
      <div class="flex items-center justify-between">
        <div class="flex items-center">
          <button class="back-btn" [routerLink]="['/', userIndex, 'claims']">
            <i class="fa-solid fa-arrow-left"></i>
          </button>
          <span class="claim-autoIncr">Claim #{{claim?.autoIncr}}</span>
          <span class="fa-external_icon cursor-pointer" [routerLink]="['/', userIndex, 'quotes', claim.orderId]" [popper]="quoteNumber" [popperDisableStyle]="true" [popperPlacement]="NgxPopperjsPlacements.TOP" [popperTrigger]="NgxPopperjsTriggers.hover" [popperHideOnClickOutside]="true">
            <i class="fas fa-external-link-alt"></i>
          </span>
          <popper-content #quoteNumber class="z-50">
            <div class="text-sm text-black rounded-lg shadow-lg bg-gray-100 popover-clime-info">
              <div class="bg-white rounded-lg">
                <div class="px-2 py-2">
                  <p class="text-sm font-poppins font-semibold text-center whitespace-nowrap">View in Order {{ order?.quoteNumber }}
                    @if(order?.ordering){
                      <span>.{{ order?.ordering }}</span>
                    }
                  </p>
                </div>
              </div>
            </div>
          </popper-content>
          <div class="lastModifyClaim flex items-center">
            <span class="last-modify-label">Last Modified: {{ claim.updatedAt | date: 'short' }}</span>
            <span class="lastModifyName text-gray-900 font-medium ml-1">{{ lastModifyClaim?.name }}</span>
          </div>
        </div>
        <div class="flex items-center">
          <button class="shop-order-action" [popper]="claimAction" [popperDisableStyle]="true" [popperPlacement]="NgxPopperjsPlacements.LEFT" [popperTrigger]="NgxPopperjsTriggers.click" [popperHideOnClickOutside]="true">
            <i class="fa-solid fa-bolt"></i>
          </button>
          <button *appHasPermission="'claims_update'" (click)="EDIT_VIEW = !EDIT_VIEW" type="button" class="edit-btn-all text-white flex items-center" [ngClass]="[!EDIT_VIEW ? 'edit-btn-all-edit' : 'view-btn']">
            <i class="fa-solid " [ngClass]="[!EDIT_VIEW ? 'fa-pencil' : 'fa-check']"></i> {{ !EDIT_VIEW ? 'Edit' : 'Save'}}
          </button>
        </div>
      </div>
      <popper-content #claimAction class="z-50">
        <div class="shadow-lg orderAction-popover border border-gray-100 rounded-lg bg-white">
          <button *appHasPermission="'notifications_create'" class="rounded-t-lg" type="button" (click)="notify()">
            <i class="fas fa-bullhorn"></i>
            <span class="whitespace-nowrap">Create Notification</span>
          </button>
          @if(!(locked || isReadOnly)){
            <button (click)="openHistory()" title="Show History">
              <i class="fas fa-history"></i>
              <span>Show History</span>
            </button>
          }
          @if(!claim?._gen_pdf){
            <button (click)="generatePdf()"
              title="Generate PDF">
              <i class="fa-solid fa-file-pdf"></i>
              <span>Generate PDF</span>
            </button>
          }
          <ng-container *appHasPermission="'claims_delete'">
            @if(!locked){
              <button type="button" title="Delete ShopOrder" class="border-t border-gray-100 rounded-b-lg" (click)="onRemove.emit(claim); claimAction.hide()">
                <i class="fas fa-trash text-[#F05252]"></i>
                <span class="text-[#F05252]">Delete Claim</span>
              </button>
            }
          </ng-container>
          @if(claim?._gen_pdf){
            <button>
              <i class="fas fa-spinner fa-pulse"></i> Loading...
            </button>
          }
        </div>
      </popper-content>
    </div>
  <!-- `claim-main` stays inside this @else: it used to sit after the closing brace, so opening
       the history rendered the log list ABOVE a claim body that was still fully mounted below it.
       The matching brace is at the very end of this file, after claim-main closes. -->
  <div class="claim-main mt-2">
    @let carrierId = (claim?.customCarrierId || order?.carrier?.accountId);
    <div class="claim-info">
      <div class="relative">
        @if(newDocument){
          <div class="modal" (click)="newDocument = false"></div>
        }
        <!-- [ngClass]="{'claim_info-no-order': !claim.orderId}" -->
        <div class="claim-info-items">
          @if(['AUTO','OTHER'].includes(claim.type)){
            <div class="claim_info-left claim-cont-item">
              <div class="claim_info-left-top claim_info-edit" [ngClass]="{'claim_info-no-order': claim.orderId}">
                <div class="claim-info-item-wrapper">
                  <div class="claim-info-item flex items-center">
                    @if(claim.orderId || !EDIT_VIEW){
                      <i class="fa-solid fa-hashtag claim-info_icon"></i>
                    }
                    @if(claim.orderId){
                      <div class="orderQuoteNumber">
                        <span class="input-read-label">Order</span>
                        <a class="input-read-value" [routerLink]="['/', userIndex, 'quotes', claim.orderId]">
                          {{ order?.quoteNumber}}
                          @if(order?.ordering){
                            <span>.{{ order?.ordering }}</span>
                          }
                        </a>
                      </div>
                    }
                    @if(!claim.orderId && !EDIT_VIEW){
                      <div class="orderQuoteNumber">
                        <span class="input-read-label">Order</span>
                        <span class="input-read-value">-</span>
                      </div>
                    }
                    @if(!claim.orderId && EDIT_VIEW){
                      <app-search
                        [idInfo]="'order-search'"
                        [label]="'Order'"
                        [resource]="'ORDER'"
                        [isReadOnly]="locked || isReadOnly"
                        [method]="'getAll'"
                        [options]="{focus: true}"
                        [filter]="{billingContactId: $safeNavigationMigration(claim?.claimant?.accountId), withoutClaim: true}"
                        (onChange)="setClaimOrder($event)"
                      ></app-search>
                    }

                  </div>
                </div>
                <div class="claim-info-item-wrapper">
                  <div class="claim-info-item flex items-center">
                    <i class="fa-solid fa-hashtag claim-info_icon" [ngStyle]="{'margin-top': !order?.refNumber || order?.refNumber == '' ? '10px' : null}"></i>
                    <div class="orderQuoteNumber">
                      <span class="input-read-label">Order REF</span>
                      <span class="input-read-value">{{order?.refNumber}}</span>
                    </div>
                  </div>
                </div>
              </div>
              @if((claim.type == 'AUTO' || claim.type == 'OTHER') && claim?.orderId){
                <div class="claim_info-left-bottom">
                  <div class="order_accounts">
                    @for(item of order?.accounts; track $index){
                      <a
                        class="pay_value" title="{{item.type}} {{item.status}}"
                        href="{{ qbUrl }}/app/{{item.type === 'INVOICE'?'invoice':'recvpayment'}}?txnId={{ item.number }}"
                        [ngClass]="{
                          'text-red-800 bg-red-100': item.status === 'DRAFT',
                          'text-yellow-800 bg-yellow-100': item.status === 'PENDING' || item.status === 'UNPAID',
                          'text-green-800 bg-green-100': item.status === 'PAID',
                          'text-purple-800 bg-purple-100': item.status === 'CREATED',
                          'text-gray-800 bg-gray-100': item.status === 'CANCELLED',
                          'text-amber-800 bg-amber-100': item.status === 'SENT'
                        }"
                      >
                          {{item.type | titlecase}}: {{item?.number}}
                      </a>
                    }
                  </div>
                </div>
              }
            </div>
          }
          <div class="claim_info-center claim-cont-item relative relative" [ngClass]="{'claim_info-center-truck': claim.type !== 'AUTO' && claim.type !== 'OTHER'}">
            @if(!(locked || isReadOnly) && claim.orderId){
              <div class="remove-order-btn">
                <app-btn-confirm (onConfirm)="patchClaim({
                  orderId: null,
                  location: { address: claim.location.address },
                  vehicles: []
                })"></app-btn-confirm>
              </div>
            }
            <div class="claim_info-center-top" [ngClass]="{'claim_info-edit': EDIT_VIEW}">
              <div [ngClass]="{'claim-info-item-wrapper': !EDIT_VIEW}">
                <div class="claim-info-item" [ngClass]="{'claim-info_edit': EDIT_VIEW, 'flex items-center': !EDIT_VIEW}">
                  @if(!EDIT_VIEW){
                    <i class="fa-solid fa-user claim-info_icon"></i>
                  }
                  <app-select
                    [idInfo]="'claim-assignee'"
                    [keyName]="{key:'_id', name:'name'}"
                    [list]="users"
                    [value]="$safeNavigationMigration(claim?.assignee?._id)"
                    [options]="{users:true}"
                    [label]="'Assigned:'"
                    [readView]="!EDIT_VIEW"
                    [placeholder]="'Select Assignee'"
                    (onSave)="setAssignee($event)"
                  ></app-select>
                </div>
              </div>
              <div [ngClass]="{'claim-info-item-wrapper': !EDIT_VIEW}">
                <div class="claim-info-item" [ngClass]="{'claim-info_edit': EDIT_VIEW, 'flex items-center': !EDIT_VIEW}">
                  @if(!EDIT_VIEW){
                    <i class="fa-solid fa-print claim-info_icon" [ngStyle]="{'margin-top': !claim?.refNumber || claim?.refNumber == '' ? '10px' : null}"></i>
                  }
                  <app-input
                    [idInfo]="'claim-refNumber'"
                    [value]="$safeNavigationMigration(claim?.refNumber)"
                    [label]="'Claim REF'"
                    [type]="'name'"
                    [readView]="!EDIT_VIEW"
                    (onSave)="patchClaim({ refNumber: $event })"
                    >
                  </app-input>
                </div>
              </div>
              <div [ngClass]="{'claim-info-item-wrapper': !EDIT_VIEW}">
                <div class="claim-info-item" [ngClass]="{'claim-info_edit': EDIT_VIEW, 'flex items-center': !EDIT_VIEW}">
                  @if(!EDIT_VIEW){
                    <i class="fa-solid fa-headset claim-info_icon"></i>
                  }
                  <app-input
                    [idInfo]="'claim-adjuster'"
                    [value]="$safeNavigationMigration(claim?.creator?.name)"
                    [label]="'Adjuster'"
                    [type]="'name'"
                    [readView]="!EDIT_VIEW"
                    (onSave)="patchAdjuster($event)"
                    >
                  </app-input>
                </div>
              </div>
              <div [ngClass]="{'claim-info-item-wrapper': !EDIT_VIEW}">
                <div class="claim-info-item" [ngClass]="{'claim-info_edit': EDIT_VIEW, 'flex items-center': !EDIT_VIEW}">
                  @if(!EDIT_VIEW){
                    <i class="fa-solid fa-wave-square claim-info_icon"></i>
                  }
                  <app-select
                    [idInfo]="'claim-status'"
                    [label]="'Status'"
                    [list]="statuses"
                    [value]="claim.status"
                    [readView]="!EDIT_VIEW"
                    [placeholder]="'Select Status'"
                    [isReadOnly]="locked || isReadOnly"
                    (onSave)="patchClaim({ status: $event })"
                  ></app-select>
                </div>
              </div>
            </div>
            <div class="claim_info-left-bottom" [ngClass]="{'claim_info-center-bottom': claim.type !== 'AUTO' && claim.type !== 'OTHER'}">
              <div class="flex items-center">
                <div class="flex subStatuses-claims">
                  @for(subStatus of subStatuses; track subStatus?.key){
                    <button [disabled]="locked || isReadOnly || !EDIT_VIEW"
                      type="button" class="subStatuses" [ngClass]="{
                        'bg-blue-100': claim?.subStatus === subStatus.key,
                        'btn_hover': claim?.subStatus !== subStatus.key && EDIT_VIEW
                      }"
                      (click)="patchClaim({ subStatus: subStatus.key })"
                      >
                      {{ subStatus.name | titlecase }}
                    </button>
                  }

                </div>
              </div>
            </div>
          </div>
          <div class="claim_info-right claim-cont-item relative">
            <div class="claim_info-date" [ngClass]="{'view_dates': !EDIT_VIEW}">
              <p class="claim_info-title">Create Date</p>
              <app-date
                [startKey]="'createdAt'"
                [parent]="claim"
                [options]="{ disabled: true }"
                [readView]="!EDIT_VIEW"
              ></app-date>
            </div>
            <div class="claim_info-date" [ngClass]="{'view_dates': !EDIT_VIEW}">
              <p class="claim_info-title">Date of Loss</p>
              <app-date
                [startKey]="'incidentDate'"
                [parent]="claim"
                [readView]="!EDIT_VIEW"
                (onSave)="updateDate('incidentDate', $event.incidentDate)"
                [options]="{ disabled: locked || isReadOnly }"
              ></app-date>
            </div>
            <div class="claim_info-date" [ngClass]="{'view_dates': !EDIT_VIEW}">
              <p class="claim_info-title">Close Date</p>
              <app-date
                [startKey]="'closeDate'"
                [parent]="claim"
                [readView]="!EDIT_VIEW"
                (onSave)="updateDate('closeDate', $event.closeDate)"
                [options]="{ disabled: locked || isReadOnly }"
              ></app-date>
            </div>
          </div>
        </div>
        <div class="flex w-full">
          <div class="claim_details-left">
            <div class="claim_info_item claim-cont-item claim_details">
              <div class="subStatuses_wr">
                <div class="loss-wrapper">
                  <p class="item_det-title">Couse of loss</p>
                  <div class="types-claims">
                    <button [disabled]="locked || isReadOnly || !EDIT_VIEW" type="button" class="claim-type"
                    [ngClass]="{
                      'bg-blue-100': claim?.type == 'AUTO',
                      'btn_hover cursor-pointer': claim?.type !== 'AUTO' && EDIT_VIEW
                    }"
                      (click)="setClaimType('AUTO')">
                      Auto
                    </button>

                    <button [disabled]="locked || isReadOnly || !EDIT_VIEW" type="button" class="claim-type"
                    [ngClass]="{
                      'bg-blue-100': claim?.type == 'TRUCK',
                      'btn_hover cursor-pointer': claim?.type !== 'TRUCK' && EDIT_VIEW
                    }"
                      (click)="setClaimType('TRUCK')">
                      Truck
                    </button>

                    <button [disabled]="locked || isReadOnly || !EDIT_VIEW" type="button" class="claim-type"
                    [ngClass]="{
                      'bg-blue-100': claim?.type == 'OTHER',
                      'btn_hover cursor-pointer': claim?.type !== 'OTHER' && EDIT_VIEW
                    }"
                      (click)="setClaimType('OTHER')">
                      Other
                    </button>
                  </div>
                </div>
                <div class="claim-tags-wrapper" [ngClass]="{'pl-3': locked || isReadOnly || !EDIT_VIEW}">
                  <p class="item_det-title pb-[6px]" [ngClass]="{'pb-2': locked || isReadOnly || !EDIT_VIEW}">Tags</p>
                  <app-multi-select
                    [idInfo]="'claim-sources'"
                    [keyName]="{key:'value', name: 'label'}"
                    [data]="sources"
                    [value]="source"
                    [readView]="locked || isReadOnly || !EDIT_VIEW"
                    [options]="{search:true, selectAll:true, noLable: true}"
                    [visibleCount]="2"
                    [label]="'Tags'"
                    (onSave)="saveSource($event)">
                  </app-multi-select>

                  <!-- <app-multi-select
                    [idInfo]="'bay-states'+$index"
                    [visibleCount]="8"
                    [options]="{search:true, borderNone: true}"
                    [data]="states" [value]="bay.states"
                    [keyName]="{key:'value', name: 'label'}"
                    [label]="'States:'"
                    (onSave)="setBayState($event, $index)">
                  </app-multi-select>  -->

                </div>
              </div>
            </div>
            <div class="carrier-claimant-info">
              <div class="claim_info_item claim-cont-item-small">
                <p class="item_det-title">Carrier Info</p>
                <div class="claimant-container">
                  <div class="relative info-block-item">
                    @if(carrierId){
                      <div class="account-contact-actions flex items-center">
                        @if(!(locked || isReadOnly)){
                          <button class="edit-btn" (click)="changeContact(carrierId)">
                            <i class="fa-regular fa-pen-to-square"></i>
                          </button>
                        }
                      </div>
                    }
                    <p class="item_det-title">Carrier</p>
                    @if(carrierId){
                      <app-contact-details
                        [contact]="getContactById(carrierId)"
                        [main]="carrierId"
                        [isReadOnly]="true"
                        (onNotify)="updateClaimContactNotify($event)"
                        (onRemove)="removeCarrier('customCarrierId', claim.customCarrierId)"
                        (onAtFault)="patchClaim({ carrierAtFault: $event })"
                        [atFault]="$safeNavigationMigration(claim?.carrierAtFault)"
                        [fields]="{
                          name: { action: 'r' },
                          phones: { action: 'r' },
                          emails: { action: 'r' },
                          notify: !isReadOnly || false,
                          address: { action: 'r' }
                        }"
                        [options]="{fontSemiboldName: true, atFault: true, noEditBtn: true, onAtFaultDisable: !EDIT_VIEW}"
                      ></app-contact-details>
                    }@else {
                      <app-search
                        [resource]="'CONTACT'"
                        [idInfo]="'claim-carrier'"
                        [isReadOnly]="locked || isReadOnly"
                        [options]="{noFocus: true, createContact: true}"
                        [createOptions]="{
                          createLocalType: 'customCarrierId'
                        }"
                        [method]="'search'"
                        [filter]="{type: 'CARRIER', limit: 25, sort: 'quoteCount', dir: 'desc'}"
                        (onChange)="patchClaim({ customCarrierId: $safeNavigationMigration($event?._id) })"
                        (onCreate)="patchClaim({ customCarrierId: $safeNavigationMigration($event?.contact?._id) })"
                      ></app-search>
                    }
                  </div>
                  @if(order?.carrier?.accountId){
                    <div class="relative info-block-item">
                      @if(order?.carrier?.accountId){
                        <div class="account-contact-actions flex items-center">
                          @if(!(isReadOnly || locked)){
                            <button class="edit-btn" (click)="openPersonModal($safeNavigationMigration(getContactById($safeNavigationMigration(order?.carrier?.dispatchId))?._id))">
                              <i class="fa-regular fa-pen-to-square"></i>
                            </button>
                          }
                        </div>
                      }
                      <p class="item_det-title">Dispatch</p>
                      @if(order?.carrier?.accountId){
                        <app-contact-details
                          [contact]="getContactById($safeNavigationMigration(order?.carrier?.dispatchId))"
                          (onNotify)="updateClaimContactNotify($event)"
                          (onAtFault)="setDispatcherFault($safeNavigationMigration(order?.carrier?.dispatchId), $event)"
                          [atFault]="$safeNavigationMigration(claim?.dispatcherAtFault)"
                          [options]="{fontSemiboldName: true, atFault: true, noEditBtn: true, onAtFaultDisable: !EDIT_VIEW}"
                          (onRemove)="removeCarrier('customDispatcherId', claim.customCarrierId)"
                          [isReadOnly]="true"
                          [fields]="{
                            name: { action: 'r' },
                            notify: !isReadOnly || false,
                            phones: { action: 'r' },
                            emails: { action: 'r' }
                          }">
                        </app-contact-details>
                      }
                    </div>
                  }

                  @if(claim?.customDispatcherId){
                    <div class="relative info-block-item">
                      <div class="account-contact-actions flex items-center">
                        @if(!(isReadOnly || locked)){
                          <button class="edit-btn" (click)="openPersonModal($safeNavigationMigration(getContactById($safeNavigationMigration(claim?.customDispatcherId))?._id))">
                            <i class="fa-regular fa-pen-to-square"></i>
                          </button>
                        }
                      </div>
                      <p class="item_det-title">Dispatch</p>
                      <app-contact-details
                        [contact]="getContactById($safeNavigationMigration(claim?.customDispatcherId))"
                        [main]="$safeNavigationMigration(claim?.customDispatcherId)"
                        [isReadOnly]="true"
                        (onNotify)="updateClaimContactNotify($event)"
                        (onAtFault)="setDispatcherFault($safeNavigationMigration(order?.carrier?.dispatchId), $event)"
                        (onRemove)="removeCarrier('customDispatcherId', claim.customCarrierId)"
                        [atFault]="$safeNavigationMigration(claim?.dispatcherAtFault)"
                        [options]="{fontSemiboldName: true, atFault: true, noEditBtn: true}"
                        [fields]="{
                          name: { action: 'r' },
                          phones: { action: 'r' },
                          notify: !isReadOnly || false,
                          emails: { action: 'r' },
                          address: { action: 'r' },
                          edit: !(locked || isReadOnly)
                        }">
                      </app-contact-details>
                    </div>
                  }@else if(!order?.carrier?.dispatchId && !isReadOnly){
                    <div class="relative info-block-item">
                      <app-search
                        [label]="'Dispatch'"
                        [resource]="'CONTACT'"
                        [idInfo]="'claim-Dispatch'"
                        [isReadOnly]="locked || isReadOnly"
                        [options]="{noFocus: true, createContact: true,}"
                        [createOptions]="{
                          createLocalType: 'customDispatcherId'
                        }"
                        [method]="'search'"
                        [filter]="{type: 'DISPATCH', limit: 25, sort: 'quoteCount', dir: 'desc'}"
                        (onChange)="patchClaim({ customDispatcherId: $safeNavigationMigration($event?._id) })"
                        (onCreate)="patchClaim({ customDispatcherId: $safeNavigationMigration($event?.contact?._id) })"
                      ></app-search>
                  </div>
                  }


                  <div>
                    @if(order?.carrier?.driverIds){
                      <div>
                        @for(driverId of order?.carrier?.driverIds; track $index){
                          <div class="relative info-block-item">
                            <p class="item_det-title">Driver</p>
                            <div class="account-contact-actions flex items-center">
                              @if(!(isReadOnly || locked)){
                                <button class="edit-btn" (click)="openPersonModal(driverId)">
                                  <i class="fa-regular fa-pen-to-square"></i>
                                </button>
                              }
                            </div>
                            @let driver = getContactById(driverId);
                            @let driverAtFault = $safeNavigationMigration(claim?.driversFault?.includes(driverId));
                            <app-contact-details
                              [contact]="driver"
                              (onNotify)="updateClaimContactNotify($event)"
                              (onAtFault)="setDriversFault(driverId, $event)"
                              [atFault]="driverAtFault"
                              [options]="{fontSemiboldName: true, atFault: true, noEditBtn: true, onAtFaultDisable: !EDIT_VIEW}"
                              [isReadOnly]="locked || isReadOnly || !EDIT_VIEW"
                              [fields]="{
                                name: { action: 'r' },
                                phones: { action: 'r' },
                                notify: !isReadOnly || false,
                                emails: { action: 'r' }
                              }">
                            </app-contact-details>
                            <div *appHasPermission="'contact_contact_bucket'">
                              @let spendBuckets = getContactBucketsByType(driverId, 'SPEND');
                              @if(spendBuckets?.length){
                                <div class="flex flex-col w-full gap-1">
                                  <span>Deductions from Bucket</span>
                                  @for(bucket of spendBuckets; track bucket._id){
                                    <div class="flex items-center justify-between py-1">
                                      <span>#{{bucket.depositNumber}}</span>
                                      <span class="px-1 py-0.5 rounded-md bg-red-100 text-red-600">
                                        -
                                        ${{bucket.amount | myCurrency}}
                                      </span>
                                    </div>
                                  }
                                </div>
                              }
                              @if(driver?._bucketBalance && driverAtFault && claim.subStatus === 'ACCEPTED'){
                                <div class="flex flex-col mt-1 gap-2">
                                  @let bucket = bucketContact.get(driverId);
                                  <div class="flex items-center justify-between">
                                    <div>
                                      Bucket Balance:
                                      <span class="font-medium">${{$safeNavigationMigration(driver?._bucketBalance) | myCurrency}}</span>
                                    </div>
                                    @if((!locked && !isReadOnly && EDIT_VIEW)){
                                      <button class="py-2 font-medium rounded-md" [ngClass]="{
                                        'bg-green-100 text-green-600 px-3': $safeNavigationMigration(bucket?.toggle),
                                        'bg-gray-200 text-gray-500 px-2': !bucket?.toggle,
                                        'cursor-not-allowed': bucket?.toggle && !bucket?.amount
                                      }" [disabled]="bucket?.toggle && !bucket?.amount" (click)="bucket?.toggle ? saveManualDeduct(driverId) : bucketContact.set(driverId, { toggle: true, amount: 0 })">
                                          {{bucket?.toggle ? 'Save' : 'Deduct'}}
                                      </button>
                                    }
                                  </div>
                                  <div class="flex items-center justify-between">
                                    @if(bucket?.toggle){
                                      <app-price
                                          [idInfo]="'contact-manual-deduct'"
                                          [value]="$safeNavigationMigration(bucket?.amount)"
                                          (onSave)="bucket.amount = $event"
                                          [isReadOnly]="isReadOnly"
                                          [max]="$safeNavigationMigration(driver?._bucketBalance)"
                                      >
                                      </app-price>
                                      <button class="bg-gray-200 text-gray-500 rounded-md py-2 px-2" (click)="bucketContact.delete(driverId)">
                                        Cancel
                                      </button>
                                    }
                                  </div>
                                </div>
                              }
                              @let transferBuckets = getContactBucketsByType(driverId, 'TRANSFER');
                              @if(transferBuckets?.length){
                                <div class="flex flex-col w-full mt-1 gap-1">
                                  <div class="flex items-center justify-between">
                                    <span>Deductions from Trips</span>
                                    @let totalDecutionsFromTripBuckets = getTotalDecutionsFromBuckets(driverId, 'TRANSFER');
                                    <span class="px-1 py-0.5 rounded-md font-semibold whitespace-nowrap">
                                      Total: ${{totalDecutionsFromTripBuckets | myCurrency}}
                                    </span>
                                  </div>
                                  @for(bucket of transferBuckets; track bucket._id){
                                    <div class="flex items-center justify-between py-1 gap-[10px]">
                                      <span>#{{bucket.depositNumber}}</span>
                                      <span>{{bucket.resourceName}}</span>
                                      <span class="px-1 py-0.5 rounded-md bg-red-100 text-red-600 whitespace-nowrap">
                                        - ${{bucket.amount | myCurrency}}
                                      </span>
                                    </div>
                                  }
                                </div>
                              }
                              @if((!locked && !isReadOnly && EDIT_VIEW) && driverAtFault && claim.subStatus === 'ACCEPTED'){
                                <div class="flex flex-col mt-2 gap-2">
                                  @let bucket = bucketContactTransfer.get(driverId);
                                  <div class="flex items-center justify-between">
                                    <div>
                                      Deduct from Trip:
                                    </div>
                                    @if(!bucket?.toggle){
                                      <button
                                        class="py-2 font-medium rounded-md bg-gray-200 text-gray-500 px-2"
                                        (click)="bucketContactTransfer.set(driverId, { toggle: true, amount: 0, sourceId: null, sourceName: null })"
                                      >
                                          {{'Deduct'}}
                                      </button>
                                    }
                                  </div>
                                  <div class="flex flex-col items-start w-full gap-1">
                                    <div class="flex items-center justify-between w-full">
                                      @if(bucket?.toggle){
                                          <app-price
                                            class="w-[60%]"
                                            [idInfo]="'contact-manual-deduct'"
                                            [value]="$safeNavigationMigration(bucket?.amount)"
                                            (onSave)="bucket.amount = $event"
                                            [isReadOnly]="isReadOnly"
                                          >
                                        </app-price>
                                        @let disabled = bucket?.toggle && (!bucket?.amount || !bucket?.sourceId);
                                        <button class="py-2 font-medium rounded-md" [ngClass]="{
                                          'bg-green-100 text-green-600 px-3': $safeNavigationMigration(bucket?.toggle),
                                          'bg-gray-200 text-gray-500 px-2': !bucket?.toggle,
                                          'cursor-not-allowed': disabled
                                        }" [disabled]="disabled" (click)="bucket?.toggle ? saveManualDeductTransfer(driverId) : bucketContactTransfer.set(driverId, { toggle: true, amount: 0, sourceId: null, sourceName: null })">
                                            {{bucket?.toggle ? 'Save' : 'Deduct'}}
                                        </button>
                                      }
                                    </div>
                                    @if(bucket?.toggle){
                                      <div class="flex items-center justify-between w-full">
                                        @if(bucket?.sourceId){
                                          <app-input
                                            class="w-[60%]"
                                            [value]="$safeNavigationMigration(bucket?.sourceName)"
                                            [disabled]="true"
                                            [label]="'Selected Trip'"
                                            [idInfo]="'resource-selected'"
                                            [options]="{ customHeight: '37px', canRemove: true }"
                                            (onRemove)="bucket.sourceId = null; bucket.sourceName = null;"
                                          >
                                          </app-input>
                                        }@else {
                                          <app-search
                                              class="w-[60%]"
                                              [label]="'Trip search'"
                                              [resource]="'TRIP'"
                                              [idInfo]="'trip-search'"
                                              [isReadOnly]="isReadOnly"
                                              [method]="'getAll'"
                                              [limit]="25"
                                              (onChange)="bucket.sourceId = $event._id; bucket.sourceName = $event.tripName;"
                                              [filter]="{
                                                driverId: driverId,
                                                driverPaid: false
                                              }"
                                          >
                                          </app-search>
                                        }
                                        <button class="bg-gray-200 text-gray-500 rounded-md py-2 px-2" (click)="bucketContactTransfer.delete(driverId)">
                                          Cancel
                                        </button>
                                      </div>
                                    }
                                  </div>
                                </div>
                              }
                            </div>
                          </div>
                        }
                      </div>
                    }

                    @for(driverId of claim?.additionalDriverIds; track $index){
                      <div class="relative info-block-item">
                        <div class="account-contact-actions flex items-center">
                          @if(!(isReadOnly || locked)){
                            <button class="edit-btn" (click)="openPersonModal(driverId)">
                              <i class="fa-regular fa-pen-to-square"></i>
                            </button>
                            <div class="remove-btn">
                              <app-btn-confirm
                                (onConfirm)="removeAdditionalDriver(getContactById(driverId))"
                              ></app-btn-confirm>
                            </div>
                          }
                        </div>
                        <p class="item_det-title">Additional Driver</p>
                        @let driver = getContactById(driverId);
                        @let driverAtFault = claim?.driversFault ? claim?.driversFault.includes(driverId) : false;
                        <app-contact-details class="contact_box-claim"
                          [contact]="driver"
                          [isReadOnly]="true"
                          [atFault]="claim?.driversFault ? claim?.driversFault.includes(driverId) : false"
                          [options]="{fontSemiboldName: true, atFault: true, noEditBtn: true, onAtFaultDisable: !EDIT_VIEW}"
                          [fields]="{
                            name: { action: 'r' },
                            phones: { action: 'r' },
                            emails: { action: 'r' },
                            notify: !isReadOnly || false
                          }"
                          (onRemove)="removeAdditionalDriver($event)"
                          (onNotify)="updateClaimContactNotify($event)"
                          (onAtFault)="setDriversFault(driverId, $event)"
                        ></app-contact-details>
                        <div *appHasPermission="'contact_contact_bucket'">
                          @let spendBuckets = getContactBucketsByType(driverId, 'SPEND');
                          @if(spendBuckets?.length){
                            <div class="flex flex-col w-full gap-1">
                              <span>Deductions from Bucket</span>
                              @for(bucket of spendBuckets; track bucket._id){
                                <div class="flex items-center justify-between py-1">
                                  <span>#{{bucket.depositNumber}}</span>
                                  <span class="px-1 py-0.5 rounded-md bg-red-100 text-red-600">
                                    -
                                    ${{bucket.amount | myCurrency}}
                                  </span>
                                </div>
                              }
                            </div>
                          }
                          @if(driver?._bucketBalance && driverAtFault && claim.subStatus === 'ACCEPTED'){
                            <div class="flex flex-col mt-1 gap-2">
                              @let bucket = bucketContact.get(driverId);
                              <div class="flex items-center justify-between">
                                <div>
                                  Bucket Balance:
                                  <span class="font-medium">${{$safeNavigationMigration(driver?._bucketBalance) | myCurrency}}</span>
                                </div>
                                @if((!locked && !isReadOnly && EDIT_VIEW)){
                                  <button class="py-2 font-medium rounded-md" [ngClass]="{
                                    'bg-green-100 text-green-600 px-3': $safeNavigationMigration(bucket?.toggle),
                                    'bg-gray-200 text-gray-500 px-2': !bucket?.toggle,
                                    'cursor-not-allowed': bucket?.toggle && !bucket?.amount
                                  }" [disabled]="bucket?.toggle && !bucket?.amount" (click)="bucket?.toggle ? saveManualDeduct(driverId) : bucketContact.set(driverId, { toggle: true, amount: 0 })">
                                      {{bucket?.toggle ? 'Save' : 'Deduct'}}
                                  </button>
                                }
                              </div>
                              <div class="flex items-center justify-between">
                                @if(bucket?.toggle){
                                  <app-price
                                      [idInfo]="'contact-manual-deduct'"
                                      [value]="$safeNavigationMigration(bucket?.amount)"
                                      (onSave)="bucket.amount = $event"
                                      [isReadOnly]="isReadOnly"
                                      [max]="$safeNavigationMigration(driver?._bucketBalance)"
                                  >
                                  </app-price>
                                  <button class="bg-gray-200 text-gray-500 rounded-md py-2 px-2" (click)="bucketContact.delete(driverId)">
                                    Cancel
                                  </button>
                                }
                              </div>
                            </div>
                          }
                          @let transferBuckets = getContactBucketsByType(driverId, 'TRANSFER');
                          @if(transferBuckets?.length){
                            <div class="flex flex-col w-full mt-1 gap-1">
                              <div class="flex items-center justify-between">
                                <span>Deductions from Trips</span>
                                @let totalDecutionsFromTripBuckets = getTotalDecutionsFromBuckets(driverId, 'TRANSFER');
                                <span class="px-1 py-0.5 rounded-md font-semibold whitespace-nowrap">
                                  Total: ${{totalDecutionsFromTripBuckets | myCurrency}}
                                </span>
                              </div>
                              @for(bucket of transferBuckets; track bucket._id){
                                <div class="flex items-center justify-between py-1 gap-[10px]">
                                  <span>#{{bucket.depositNumber}}</span>
                                  <span>{{bucket.resourceName}}</span>
                                  <span class="px-1 py-0.5 rounded-md bg-red-100 text-red-600 whitespace-nowrap">
                                    - ${{bucket.amount | myCurrency}}
                                  </span>
                                </div>
                              }
                            </div>
                          }
                          @if((!locked && !isReadOnly && EDIT_VIEW) && driverAtFault && claim.subStatus === 'ACCEPTED'){
                            <div class="flex flex-col mt-2 gap-2">
                              @let bucket = bucketContactTransfer.get(driverId);
                              <div class="flex items-center justify-between">
                                <div>
                                  Deduct from Trip:
                                </div>
                                @if(!bucket?.toggle){
                                  <button
                                    class="py-2 font-medium rounded-md bg-gray-200 text-gray-500 px-2"
                                    (click)="bucketContactTransfer.set(driverId, { toggle: true, amount: 0, sourceId: null, sourceName: null })"
                                  >
                                      {{'Deduct'}}
                                  </button>
                                }
                              </div>
                              <div class="flex flex-col items-start w-full gap-1">
                                <div class="flex items-center justify-between w-full">
                                  @if(bucket?.toggle){
                                      <app-price
                                        class="w-[60%]"
                                        [idInfo]="'contact-manual-deduct'"
                                        [value]="$safeNavigationMigration(bucket?.amount)"
                                        (onSave)="bucket.amount = $event"
                                        [isReadOnly]="isReadOnly"
                                      >
                                    </app-price>
                                    @let disabled = bucket?.toggle && (!bucket?.amount || !bucket?.sourceId);
                                    <button class="py-2 font-medium rounded-md" [ngClass]="{
                                      'bg-green-100 text-green-600 px-3': $safeNavigationMigration(bucket?.toggle),
                                      'bg-gray-200 text-gray-500 px-2': !bucket?.toggle,
                                      'cursor-not-allowed': disabled
                                    }" [disabled]="disabled" (click)="bucket?.toggle ? saveManualDeductTransfer(driverId) : bucketContactTransfer.set(driverId, { toggle: true, amount: 0, sourceId: null, sourceName: null })">
                                        {{bucket?.toggle ? 'Save' : 'Deduct'}}
                                    </button>
                                  }
                                </div>
                                @if(bucket?.toggle){
                                  <div class="flex items-center justify-between w-full">
                                    @if(bucket?.sourceId){
                                      <app-input
                                        class="w-[60%]"
                                        [value]="$safeNavigationMigration(bucket?.sourceName)"
                                        [disabled]="true"
                                        [label]="'Selected Trip'"
                                        [idInfo]="'resource-selected'"
                                        [options]="{ customHeight: '37px', canRemove: true }"
                                        (onRemove)="bucket.sourceId = null; bucket.sourceName = null;"
                                      >
                                      </app-input>
                                    }@else {
                                      <app-search
                                          class="w-[60%]"
                                          [label]="'Trip search'"
                                          [resource]="'TRIP'"
                                          [idInfo]="'trip-search'"
                                          [isReadOnly]="isReadOnly"
                                          [method]="'getAll'"
                                          [limit]="25"
                                          (onChange)="bucket.sourceId = $event._id; bucket.sourceName = $event.tripName;"
                                          [filter]="{
                                            driverId: driverId,
                                            driverPaid: false
                                          }"
                                      >
                                      </app-search>
                                    }
                                    <button class="bg-gray-200 text-gray-500 rounded-md py-2 px-2" (click)="bucketContactTransfer.delete(driverId)">
                                      Cancel
                                    </button>
                                  </div>
                                }
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    }
                    <div class="relative info-block-item mt-[10px]">
                      <app-search
                        [label]="'Driver'"
                        [resource]="'CONTACT'"
                        [idInfo]="'claim-Dispatch'"
                        [isReadOnly]="locked || isReadOnly"
                        [options]="{noFocus: true, createContact: true}"
                        [createOptions]="{
                          createLocalType: 'driver'
                        }"
                        [method]="'search'"
                        [filter]="{type: 'DRIVER', accountId: $safeNavigationMigration(order?.carrier?.accountId), limit: 25, sort: 'quoteCount', dir: 'desc', active: true}"
                        (onChange)="addAdditionalDriver($event)"
                        (onCreate)="addAdditionalDriver($event.contact)"
                      ></app-search>
                    </div>
                  </div>
                </div>
              </div>
              <div class="claim_info_item claim-cont-item-small">
                <p class="item_det-title">Claimant Info</p>
                <div class="claimant-container z-[5]">
                  @if (claim?.claimant?.accountId) {
                    <div class="relative info-block-item">
                      <div class="account-contact-actions flex items-center">
                        @if(!(locked || isReadOnly)){
                          <button class="edit-btn" (click)="changeContact($safeNavigationMigration(claim?.claimant?.accountId))">
                            <i class="fa-regular fa-pen-to-square"></i>
                          </button>
                          @if(claim?.type != 'AUTO'){
                            <div class="remove-btn">
                              <app-btn-confirm
                                (onConfirm)="removeClaiment('accountId', $safeNavigationMigration(claim?.claimant?.accountId))"
                              ></app-btn-confirm>
                            </div>
                          }
                        }
                      </div>
                      <app-contact-details
                        [contact]="getContactById($safeNavigationMigration(claim?.claimant?.accountId))"
                        [main]="$safeNavigationMigration(claim?.claimant?.accountId)"
                        (onRemove)="patchClaim({
                          claimant: {
                            contacts: []
                          },
                          vehicles: []
                        })"
                        (onNotify)="updateClaimContactNotify($event)"
                        [isReadOnly]="true"
                        [fields]="{
                          name: { action: 'r' },
                          type: { action: 'r' },
                          phones: { action: 'r' },
                          emails: { action: 'r' },
                          notify: !isReadOnly || false,
                          contact: false,
                        }"
                        [options]="{fontSemiboldName: true, noEditBtn: true}"
                      >
                      </app-contact-details>
                    </div>
                  }
                  @if(claim?.claimant?.contacts?.length){
                    <div>
                      @for(claimant of claim?.claimant?.contacts; track $index){
                        <div class="relative info-block-item">
                          <div class="account-contact-actions flex items-center">
                            @if(!(locked || isReadOnly)){
                              <button class="edit-btn" (click)="openPersonModal(claimant)">
                                <i class="fa-regular fa-pen-to-square"></i>
                              </button>
                              @if(claim?.type != 'AUTO'){
                                <div class="remove-btn">
                                  <app-btn-confirm
                                    (onConfirm)="removeClaiment('claimantContactId', claimant)"
                                  ></app-btn-confirm>
                                </div>
                              }
                            }
                          </div>
                          <app-contact-details
                            [contact]="getContactById(claimant)"
                            [main]="$safeNavigationMigration(claim?.claimant?.accountId)"
                            (onRemove)="patchClaim({
                              claimant: {
                                contacts: []
                              },
                              vehicles: []
                            })"
                            (onNotify)="updateClaimContactNotify($event)"
                            [isReadOnly]="true"
                            [fields]="{
                              name: { action: 'r' },
                              type: { action: 'r' },
                              phones: { action: 'r' },
                              emails: { action: 'r' },
                              notify: !isReadOnly || false,
                              contact: false,
                            }"
                            [options]="{fontSemiboldName: true, noEditBtn: true}"
                          >
                          </app-contact-details>
                        </div>
                      }
                    </div>
                  }
                  @if(claim?.type != 'AUTO'){
                    <div class="mt-2">
                      <app-search
                        [resource]="'CONTACT'"
                        [isReadOnly]="locked || isReadOnly"
                        [idInfo]="'claim-WITH_ORDERS'"
                        [options]="claim?.claimant?.accountId ? {createContact: true} : {noFocus: true, createContact: true, selectType: true}"
                        [createOptions]="{createLocalType: 'claimant'}"
                        [method]="'search'"
                        [filter]="{accountId: $safeNavigationMigration(claim?.claimant?.accountId), type: claim?.claimant?.accountId ? null : 'WITH_ORDERS', limit: 25, sort: 'quoteCount', dir: 'desc', active: true}"
                        (onChange)="addClaimantContact(claim?.claimant?.accountId ? 'contacts' : 'accountId', $event)"
                        (onCreate)="addClaimantContact(claim?.claimant?.accountId ? 'contacts' : 'accountId', $event.contact)"
                      ></app-search>
                    </div>
                  }
                  <p class="lowest-quote">Lowest Quote:<span>${{lowestQuote ? (trunc(lowestQuote) | myCurrency) : '0.00'}}</span></p>
                  <div class="driver-deduct">
                    <div class="driver-item flex items-center">
                      <app-btn-toggle
                        [disabled]="locked || isReadOnly || !EDIT_VIEW"
                        [checkbox]="true"
                        [value]="$safeNavigationMigration(claim.amounts?.responsible?.driverDeduct)"
                        (onToggle)="patchClaim({'amounts.responsible.driverDeduct': !claim.amounts?.responsible?.driverDeduct})"
                      >
                      </app-btn-toggle>
                      <span class="driver-title">Driver Deduct</span>
                    </div>
                    <div class="driver-item flex items-center">
                      <app-btn-toggle
                        [disabled]="locked || isReadOnly || !EDIT_VIEW"
                        [checkbox]="true"
                        [value]="$safeNavigationMigration(claim.amounts?.responsible?.customerReimbursed)"
                        (onToggle)="patchClaim({'amounts.responsible.customerReimbursed': !claim.amounts?.responsible?.customerReimbursed})"
                      >
                      </app-btn-toggle>
                      <span class="driver-title">Customer Reimbursed</span>
                    </div>
                  </div>
                  <div class="pointOfContact">
                    <p class="item_det-title">Point Of Contact</p>
                    <div class="driver-item flex items-center pb-3">
                      <input
                        id="default-checkbox"
                        type="checkbox"
                        name="pointOfContactFilterByClaimant"
                        [(ngModel)]="pointOfContactFilterByClaimant"
                        [disabled]="locked || isReadOnly || !EDIT_VIEW"
                        [ngStyle]="{'cursor': locked || isReadOnly || !EDIT_VIEW ? 'not-allowed' : null}"
                        class="custom-checkbox text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                      >
                      <span class="driver-title">Subcontact</span>
                    </div>
                  </div>
                  @if(claim?.pointOfContactId){
                    <div class="relative info-block-item">
                      <div class="account-contact-actions flex items-center">
                        @if(!(locked || isReadOnly || EDIT_VIEW)){
                          <button class="edit-btn" (click)="changeContact($safeNavigationMigration(claim?.pointOfContactId))">
                            <i class="fa-regular fa-pen-to-square"></i>
                          </button>
                        }@else if(!(locked || isReadOnly || !EDIT_VIEW)){
                          <div class="remove-btn">
                            <app-btn-confirm
                              (onConfirm)="patchClaim({ pointOfContactId: null })"
                            ></app-btn-confirm>
                          </div>
                        }
                      </div>
                      <app-contact-details
                        [contact]="getContactById($safeNavigationMigration(claim?.pointOfContactId))"
                        (onRemove)="patchClaim({ pointOfContactId: null })"
                        (onNotify)="updateClaimContactNotify($event)"
                        [addNotifyToNotContact]="false"
                        [isReadOnly]="true"
                        [options]="{fontSemiboldName: true}"
                        [fields]="{
                          name: { action: 'r' },
                          type: { action: 'r' },
                          phones: { action: 'r' },
                          emails: { action: 'r' },
                          contact: false,
                          notify: !isReadOnly || false
                        }"
                      ></app-contact-details>
                    </div>
                  }@else {
                    <app-search
                      [resource]="'CONTACT'"
                      [isReadOnly]="locked || isReadOnly"
                      [idInfo]="'claim-WITH_ORDERS'"
                      [options]="{noFocus: !pointOfContactFilterByClaimant, createContact: true}"
                      [createOptions]="{
                        createLocalType: 'pointOfContactId'
                      }"
                      [method]="'search'"
                      [filter]="{accountId: pointOfContactFilterByClaimant ? $safeNavigationMigration(claim?.claimant?.accountId) : null, limit: 25, sort: 'quoteCount', dir: 'desc', active: true}"
                      (onChange)="patchClaim({ pointOfContactId: $event._id })"
                      (onCreate)="patchClaim({ pointOfContactId: $event.contact._id })"
                    ></app-search>
                  }
                </div>
              </div>
            </div>
            <div class="claim_info_item claim-cont-item-small notes_container">
              <div class="notes_container-item" [ngClass]="{'notes_container-item_view': !EDIT_VIEW}">
                <div class="item-notes relative" [ngClass]="{'bg-gray-50 rounded-lg border border-gray-300 p-2.5': EDIT_VIEW}">
                  <p [ngClass]="[EDIT_VIEW ? 'item-notes-title' : 'item_det-title']">Customer Notes</p>
                  <textarea rows="4" [disabled]="!EDIT_VIEW" [value]="claim?.claimantNotes ? $safeNavigationMigration(claim?.claimantNotes) : ''" (blur)="updateNote('claimantNotes', $any($event.target).value)" class="block w-full damage-notes-text text-sm p-0 text-gray-900 border-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Type here"
                    [ngClass]="{'edit_textarea_notes': EDIT_VIEW}"
                  ></textarea>
                  @if(claim?.claimantNotes?.length){
                    <button class="item-notes-btn" [popper]="claimantNotes" [popperDisableStyle]="true" [popperPlacement]="NgxPopperjsPlacements.TOP" [popperTrigger]="NgxPopperjsTriggers.click" [popperHideOnClickOutside]="true">
                      <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
                    </button>
                  }
                  <popper-content #claimantNotes class="z-50">
                    <div class="rounded-lg bg-white item-notes-popover-wr">
                      <div class="bg-white rounded-lg">
                        <div class="relative">
                          <div class="flex items-center justify-between">
                            <span class="item-notes-title-popover">Customer Notes</span>
                            <button class="item-notes-close" (click)="claimantNotes.hide()">
                              <i class="fas fa-close text-gray-400"></i>
                            </button>
                          </div>
                          <textarea [disabled]="!EDIT_VIEW"
                            (blur)="updateNote('claimantNotes', $any($event.target).value)"
                            class="block w-full p-0 item-notes-popover-text bg-white rounded-lg border-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="Type here"
                          >{{claim?.claimantNotes ? claim?.claimantNotes : ''}}</textarea>
                        </div>
                      </div>
                    </div>
                  </popper-content>
                </div>
                <div class="item-notes relative" [ngClass]="{'bg-gray-50 rounded-lg border border-gray-300 p-2.5': EDIT_VIEW}">
                  <p [ngClass]="[EDIT_VIEW ? 'item-notes-title' : 'item_det-title']">Dispatch Notes</p>
                  <textarea rows="4" [disabled]="!EDIT_VIEW" [value]="claim?.dispatchNotes ? $safeNavigationMigration(claim?.dispatchNotes) : ''" (blur)="updateNote('dispatchNotes', $any($event.target).value)" class="block w-full damage-notes-text text-sm p-0 text-gray-900 border-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Type here"
                    [ngClass]="{'edit_textarea_notes': EDIT_VIEW}"
                  ></textarea>
                  @if(claim?.dispatchNotes?.length){
                    <button class="item-notes-btn" [popper]="dispatchNotes" [popperDisableStyle]="true" [popperPlacement]="NgxPopperjsPlacements.TOP" [popperTrigger]="NgxPopperjsTriggers.click" [popperHideOnClickOutside]="true">
                      <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
                    </button>
                  }
                  <popper-content #dispatchNotes class="z-50">
                    <div class="rounded-lg bg-white item-notes-popover-wr">
                      <div class="bg-white rounded-lg">
                        <div class="relative">
                          <div class="flex items-center justify-between">
                            <span class="item-notes-title-popover">Dispatch Notes</span>
                            <button class="item-notes-close" (click)="dispatchNotes.hide()">
                              <i class="fas fa-close text-gray-400"></i>
                            </button>
                          </div>
                          <textarea [disabled]="!EDIT_VIEW"
                            (blur)="updateNote('dispatchNotes', $any($event.target).value)"
                            class="block w-full p-0 item-notes-popover-text bg-white rounded-lg border-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="Type here"
                          >{{claim?.dispatchNotes ? claim?.dispatchNotes : ''}}</textarea>
                        </div>
                      </div>
                    </div>
                  </popper-content>
                </div>
                <div class="item-notes relative" [ngClass]="{'bg-gray-50 rounded-lg border border-gray-300 p-2.5': EDIT_VIEW}">
                  <p [ngClass]="[EDIT_VIEW ? 'item-notes-title' : 'item_det-title']">Driver Notes</p>
                  <textarea rows="4" [disabled]="!EDIT_VIEW" [value]="claim?.driverNotes ? $safeNavigationMigration(claim?.driverNotes) : ''" (blur)="updateNote('driverNotes', $any($event.target).value)" class="block w-full damage-notes-text text-sm p-0 text-gray-900 border-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Type here"
                    [ngClass]="{'edit_textarea_notes': EDIT_VIEW}"
                  ></textarea>
                  @if(claim?.driverNotes?.length){
                    <button class="item-notes-btn" [popper]="driverNotes" [popperDisableStyle]="true" [popperPlacement]="NgxPopperjsPlacements.TOP" [popperTrigger]="NgxPopperjsTriggers.click" [popperHideOnClickOutside]="true">
                      <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
                    </button>
                  }
                  <popper-content #driverNotes class="z-50">
                    <div class="rounded-lg bg-white item-notes-popover-wr">
                      <div class="bg-white rounded-lg">
                        <div class="relative">
                          <div class="flex items-center justify-between">
                            <span class="item-notes-title-popover">Driver Notes</span>
                            <button class="item-notes-close" (click)="driverNotes.hide()">
                              <i class="fas fa-close text-gray-400"></i>
                            </button>
                          </div>
                          <textarea [disabled]="!EDIT_VIEW"
                            (blur)="updateNote('driverNotes', $any($event.target).value)"
                            class="block w-full p-0 item-notes-popover-text bg-white rounded-lg border-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="Type here"
                          >{{claim?.driverNotes ? claim?.driverNotes : ''}}</textarea>
                        </div>
                      </div>
                    </div>
                  </popper-content>
                </div>
                <div class="item-notes relative" [ngClass]="{'bg-gray-50 rounded-lg border border-gray-300 p-2.5': EDIT_VIEW}">
                  <p [ngClass]="[EDIT_VIEW ? 'item-notes-title' : 'item_det-title']">Adjusters Notes</p>
                  <textarea rows="4" [disabled]="!EDIT_VIEW" [value]="claim?.carrierNotes ? $safeNavigationMigration(claim?.carrierNotes) : ''" (blur)="updateNote('carrierNotes', $any($event.target).value)" class="block w-full damage-notes-text text-sm p-0 text-gray-900 border-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Type here"
                    [ngClass]="{'edit_textarea_notes': EDIT_VIEW}"
                  ></textarea>
                  @if(claim?.carrierNotes?.length){
                    <button class="item-notes-btn" [popper]="carrierNotes" [popperDisableStyle]="true" [popperPlacement]="NgxPopperjsPlacements.TOP" [popperTrigger]="NgxPopperjsTriggers.click" [popperHideOnClickOutside]="true">
                      <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
                    </button>
                  }
                  <popper-content #carrierNotes class="z-50">
                    <div class="rounded-lg bg-white item-notes-popover-wr">
                      <div class="bg-white rounded-lg">
                        <div class="relative">
                          <div class="flex items-center justify-between">
                            <span class="item-notes-title-popover">Adjusters Notes</span>
                            <button class="item-notes-close" (click)="carrierNotes.hide()">
                              <i class="fas fa-close text-gray-400"></i>
                            </button>
                          </div>
                          <textarea [disabled]="!EDIT_VIEW"
                            (blur)="updateNote('carrierNotes', $any($event.target).value)"
                            class="block w-full p-0 item-notes-popover-text bg-white rounded-lg border-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="Type here"
                          >{{claim?.carrierNotes ? claim?.carrierNotes : ''}}</textarea>
                        </div>
                      </div>
                    </div>
                  </popper-content>
                </div>
              </div>
            </div>
          </div>
          <div class="claim_details-right">
            <div class="claim-details-r-top">
              <div class="claim_info_item claim-cont-item height-item vehicl_block_left flex flex-col justify-between">
                <div class="vehicles-wrapper">
                  <!-- <p class="item_det-title">Vehicles</p> -->
                  <div class="vehicles-items">
                    @for(vehicle of vehicles; track vehicle._id){
                      <div class="vehicle">
                        <div class="flex items-center justify-between relative">
                          <div class="flex items-center">
                            <button (click)="openVehicleLocation(vehicle); vehicle.showVehicleLocation = true" class="vehicle-point">
                              <i class="fa-solid fa-location-dot btn_hover"></i>
                            </button>
                            @if(vehicle?.showVehicleLocation){
                              <div class="absolute z-20 top-[-80px] left-[-105px] w-[500px]">
                                <app-vehicle-location
                                  [location]="location"
                                  [refreshTime]="refreshTime"
                                  [status]="$safeNavigationMigration(order?.status)"
                                  [address]="fullAddress"
                                  (onClose)="vehicle.showVehicleLocation = false"
                                ></app-vehicle-location>
                              </div>
                            }
                            <span class="vehicle-name">{{vehicle?.year}} {{vehicle?.make}} {{vehicle?.model}}</span>
                            @if(!vehicle?.isOperable){
                              <i title="INOP" class="fa-solid fa-car-burst vehicle-burst"></i>
                            }
                          </div>
                          <div class="flex items-center">
                            <button class="vehicle-search" [disabled]="!EDIT_VIEW" (click)="openAdjustersNotes(vehicle)">
                              <i class="fa-solid fa-magnifying-glass"></i>
                            </button>
                            <button class="vehicle-chevron" (click)="vehicle.showDetails = !vehicle.showDetails">
                              <i class="fa-solid" [ngClass]="[vehicle.showDetails ? 'fa-chevron-up' : 'fa-chevron-down']"></i>
                            </button>
                            <!-- <button class="vehicle-remove" *ngIf="canDeleteVehicle()?.vehicle?.can?.delete" [disabled]="!EDIT_VIEW" (click)="removeVehicle(vehicle)">
                              <i class="fas fa-times"></i>
                            </button> -->
                          </div>
                        </div>
                        @if(vehicle?.showDetails){
                          <div class="vehicle-item-details flex items-center justify-between">
                            <div class="flex flex-col vec-details-item">
                              <span class="vec_key">Year:</span>
                              <span class="vec_value">{{vehicle?.year}}</span>
                            </div>
                            <div class="flex flex-col vec-details-item">
                              <span class="vec_key">VIN:</span>
                              <span class="vec_value">{{vehicle?.VIN}}</span>
                            </div>
                            <div class="flex flex-col vec-details-item">
                              <span class="vec_key">Curb Weight:</span>
                              <span class="vec_value">{{vehicle?.curbWeight}}</span>
                            </div>
                            <div class="flex flex-col vec-details-item">
                              <span class="vec_key">Color:</span>
                              <span class="vec_value">{{vehicle?.color}}</span>
                            </div>
                            <div class="flex flex-col vec-details-item">
                              <span class="vec_key">Type:</span>
                              <span class="vec_value">{{vehicle?.bodyType}}</span>
                            </div>
                          </div>
                        }
                      </div>
                    }
                  </div>
                </div>
                <!-- <div class="text-right" *ngIf="canDeleteVehicle()?.vehicle?.can?.create">
                  <button class="addVehicle" [disabled]="!EDIT_VIEW" (click)="addVehicle()">Add Vehicle</button>
                </div> -->
              </div>
              @let _carrierId = (claim?.customCarrierId || order?.carrier?.accountId);
              <div class="claim_info_item claim-cont-item height-item vehicl_block_right">
                <div class="truck-trailer-wrapper">
                  <p class="item_det-title">Truck / Trailer</p>
                  <div class="truck-trailer-item relative">
                    <p class="claim_info-title">Truck</p>
                    @if(!claim.equipment?.truck){
                      @if(EDIT_VIEW){
                        <app-search
                          [idInfo]="'equipment-truck'"
                          [label]="'Unit'"
                          [resource]="'EQUIPMENT'"
                          [isReadOnly]="!_carrierId || !EDIT_VIEW"
                          [options]="{focus: true}"
                          [method]="'search'"
                          [filter]="{carrierId: _carrierId, type: 'TRUCK'}"
                          (onChange)="setUnit($event._id, $event.name, 'truck')"
                        ></app-search>
                      }@else{
                        <app-input
                          [value]="'No track selected'"
                          [readView]="true"
                        >
                        </app-input>
                      }
                    }@else {
                      <app-input
                        [value]="claim.equipment.truck.name"
                        [readView]="!EDIT_VIEW"
                        [options]="{canRemove: true}"
                        (onRemove)="removeUnit('truck')"
                      >
                      </app-input>
                    }
                  </div>
                  <div class="truck-trailer-item relative">
                    <p class="claim_info-title">Trailer</p>
                    @if(!claim.equipment?.trailer){
                      @if(EDIT_VIEW){
                        <app-search
                          [idInfo]="'equipment-trailer'"
                          [label]="'Unit'"
                          [resource]="'EQUIPMENT'"
                          [isReadOnly]="!_carrierId || !EDIT_VIEW"
                          [options]="{focus: true}"
                          [method]="'search'"
                          [filter]="{carrierId: _carrierId, type: 'TRAILER'}"
                          (onChange)="setUnit($event._id, $event.name, 'trailer')"
                        ></app-search>
                      }@else {
                        <app-input
                          [value]="'No trailer selected'"
                          [readView]="true"
                        >
                        </app-input>
                      }
                    }@else {
                      <app-input
                        [value]="claim.equipment.trailer.name"
                        [options]="{canRemove: true}"
                        [readView]="!EDIT_VIEW"
                        (onRemove)="removeUnit('trailer')"
                      >
                      </app-input>
                    }

                  </div>
                </div>
              </div>
            </div>
            <div class="claim_info_item claim-cont-item damage-notes-wrapper">
              <div class="vehicles-wrapper">
                <p class="item_det-title">Damage Notes</p>
                <!-- [disabled]="!EDIT_VIEW" -->
                <div class="" [ngClass]="{'damage-notes_items': $safeNavigationMigration(claim?.damageNotes?.length) > 1}">
                  @for(note of claim?.damageNotes; track $index){
                    <div class="damage-notes_item">
                      <p class="">{{note?.title}}</p>
                      @if(!note?.content?.length && !note.edit){
                        <label [for]="setStringFor($safeNavigationMigration(note?.title))" class="no_damage_note" [ngClass]="{'hide_no_damage_note': note.edit}" (click)="EDIT_VIEW ? clickEmptyNote(note) : null">
                          <p>No Damage Notes Here.</p>
                        </label>
                      }@else if(note?.content?.length || note.edit){
                        <textarea
                          [id]="setStringFor($safeNavigationMigration(note?.title))"
                          autogrow
                          [disabled]="!EDIT_VIEW"
                          class="block mt-1 damage-notes-textarea w-full text-sm text-gray-900 rounded-lg dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                          placeholder="Write your notes here..."
                          [value]="note?.content ? $safeNavigationMigration(note?.content) : ''"
                          (blur)="updateDamageNote(note, $any($event.target).value); note.edit = false"
                        ></textarea>
                      }
                    </div>
                  }
                  <!-- [ngClass]="{'bg-gray-50 border border-gray-300 mt-1': EDIT_VIEW, 'p-0': !EDIT_VIEW}" -->

                  <!-- <div class="damage-notes_item">
                    <p class="">2020 Tesla Model S</p>
                    <textarea
                      id="message"
                      autogrow
                      [disabled]="!EDIT_VIEW"
                      class="block damage-notes-textarea w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="Write your thoughts here..."
                    ></textarea>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="claim_info_item claim-cont-item order-info-wrapper" [ngClass]="{'edit_stops': EDIT_VIEW}">
              <div class="">
                @if(claim.type === 'AUTO' || claim.type === 'OTHER'){
                  <div class="claim_data-delivery">
                    @if(claim.location?.originId){
                      <div class="claim_pickup_item">
                        <p class="item_det-title claim_pickup_title">Order Info</p>
                        <div class="relative">
                          <app-order-stop
                          [quote]="order"
                          [getFromLocal]="true"
                          [currentUser]="currentUser"
                          [stopType]="'Pickup'"
                          [stopId]="$safeNavigationMigration(claim.location?.originId)"
                          [users]="users"
                          [options]="{ edit_view: true, address_edit: true, isNotes: true }"
                          [contactTypes]="contactTypes"
                          [EDIT_VIEW]="EDIT_VIEW"
                          ></app-order-stop>
                        </div>
                      </div>
                    }
                    @if(claim.location?.destinationId){
                      <div class="claim_delivery_item relative">
                        <app-order-stop
                          [idInfo]="'claim-stop-delivery'"
                          [quote]="order"
                          [getFromLocal]="true"
                          [currentUser]="currentUser"
                          [stopType]="'Delivery'"
                          [EDIT_VIEW]="EDIT_VIEW"
                          [stopId]="$safeNavigationMigration(claim.location?.destinationId)"
                          [users]="users"
                          [options]="{ address_edit: true, isNotes: true, edit_view: true }"
                          [contactTypes]="contactTypes"
                        ></app-order-stop>
                      </div>
                    }
                    <div class="claim_payment-wrapper" [ngClass]="{'border-l border-gray-200': claim.location?.originId || claim.location?.destinationId, 'ml-0': !claim.location?.originId || !claim.location?.destinationId}">
                      <p class="item_det-title claim_payment_title">Payment Info</p>
                      <div class="claim_payment_info">
                        <div class="transport-paid">
                          <app-btn-toggle [options]="{ disabled: isReadOnly || locked || !EDIT_VIEW }"
                            [value]="$safeNavigationMigration(claim?.transportPaid)" [label]="'Transport Paid'"
                            (onToggle)="patchClaim({ transportPaid: $event })">
                          </app-btn-toggle>

                          <div class="flex flex-col">
                            <div class="claim-payd_item" [ngClass]="{'flex items-center justify-between border-b border-gray-200 pb-3': !EDIT_VIEW}">
                              <p class="claim_info-title">How Much Was Paid</p>
                              @if(EDIT_VIEW){
                                <app-price
                                  [isReadOnly]="locked || isReadOnly || !EDIT_VIEW"
                                  [title]="'claim?.realPaidAmount'"
                                  [value]="$safeNavigationMigration(claim?.realPaidAmount)"
                                  [icon]="'fa-solid fa-dollar-sign'"
                                  [options]="{iconCurrency: true}"
                                  (onSave)="patchClaim({ realPaidAmount: $event })"
                                ></app-price>
                              }@else {
                                <div class="flex items-center claim_pay_view">
                                  <i class="fa-solid fa-dollar-sign icon_currency ml-1"></i><span>{{$safeNavigationMigration(claim?.realPaidAmount) | myCurrency}}</span>
                                </div>
                              }
                            </div>
                            <div class="claim-payd_item" [ngClass]="{'flex items-center justify-between': !EDIT_VIEW}">
                              <p class="claim_info-title">Payment Amount</p>
                              @if(EDIT_VIEW){
                                <app-price
                                  [isReadOnly]="locked || isReadOnly || !EDIT_VIEW"
                                  [title]="'claim?.paidAmount'"
                                  [icon]="'fa-solid fa-dollar-sign'"
                                  [value]="$safeNavigationMigration(claim?.paidAmount)"
                                  [options]="{iconCurrency: true}"
                                  (onSave)="patchClaim({ paidAmount: $event })"
                                ></app-price>
                              }@else{
                                <div class="flex items-center claim_pay_view">
                                  <i class="fa-solid fa-dollar-sign icon_currency ml-1"></i><span>{{$safeNavigationMigration(claim?.paidAmount) | myCurrency}}</span>
                                </div>
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                }
                <div class="assign-shop" [ngClass]="{'pt-5 border-t border-gray-200': claim.type == 'AUTO' || claim.type == 'OTHER'}">
                  <div class="assign_wr">
                    <div class="flex items-center justify-between w-full">
                      <p class="item_det-title">Assign shop</p>
                      @if(vehicles?.length){
                        <button class="show-nearby" (click)="openShopsNearby()">Shops Nearby</button>
                      }
                    </div>
                    <div class="claim-shop">
                      @if(lowestQuoteShop?._id){
                        <app-contact-details
                          [contact]="lowestQuoteShop"
                          [main]="$safeNavigationMigration(lowestQuoteShop?._id)"
                          [fields]="{
                            name: { action: 'r' },
                            phones: { action: 'r' },
                            emails: { action: 'r' },
                            notify: !isReadOnly || false,
                            address: { action: 'r' }
                          }"
                          [options]="{fontSemiboldName: true}"
                          (onRemove)="putClaim({shop: null})"
                        ></app-contact-details>
                      }@else {
                        <div class="lowestQuoteShop-empty">
                          <p class="text-center flex-1 text-gray-400">Please select shop</p>
                        </div>
                      }
                    </div>
                  </div>
                  <div class="estimates">
                    <p class="item_det-title">Estimates</p>
                    <div class="estimates-block">
                      <div class="estimates-item"
                        [ngClass]="{
                          'estimates-item-view py-2 px-2 rounded-lg': !EDIT_VIEW,
                          'active_estimate': claim?.estimates?.shopsFirst?.isLowestQuote && !EDIT_VIEW,
                          'not_active_estimate': !claim?.estimates?.shopsFirst?.isLowestQuote && !EDIT_VIEW && lowestQuote && lowestQuote !== ''
                          }">
                          @if(EDIT_VIEW){
                            <div [title]="!claim?.estimates?.shopsFirst?.price ? 'Please enter price' : ''">
                              <app-btn-toggle
                                [idInfo]="'shopsFirst'"
                                [checkbox]="true"
                                [disabled]="!claim?.estimates?.shopsFirst?.price || !EDIT_VIEW"
                                [value]="$safeNavigationMigration(claim?.estimates?.shopsFirst?.isLowestQuote)"
                                (onToggle)="setActiveShopId('shopsFirst', $event)"
                              ></app-btn-toggle>
                            </div>
                          }
                        <span class="estimates-number act_it">1.</span>
                        @if(!EDIT_VIEW){
                          <div class="flex items-center">
                            <i class="fa-solid fa-dollar-sign icon_currency act_it_icon"></i>
                            <span class="claim_estimates_view act_it font-bold">{{(claim?.estimates?.shopsFirst?.price || 000) | myCurrency}}</span>
                          </div>
                          <p class="claim_estimates_view font-bold act_it">{{claim?.estimates?.shopsFirst?.shop?.name}}</p>
                        }@else {
                          <div class="flex items-center flex-1">
                            <div class="estimates-pay">
                              <app-price
                                [value]="claim?.estimates?.shopsFirst?.price || ''"
                                [isReadOnly]="!EDIT_VIEW"
                                [icon]="'fa-solid fa-dollar-sign'"
                                [options]="{iconCurrency: true}"
                                (onSave)="setShopPrice('shopsFirst', $event)"
                              ></app-price>
                            </div>
                            <div class="estimates-shop">
                              @if(claim?.estimates?.shopsFirst?.shop?._id){
                                <app-input
                                  [idInfo]="'first'"
                                  [label]="'Truck Shop'"
                                  [isReadOnly]="true"
                                  [value]="$safeNavigationMigration(claim?.estimates?.shopsFirst?.shop?.name)"
                                  [options]="{canRemove: EDIT_VIEW}"
                                  (onRemove)="deleteShop('shopsFirst')"
                                ></app-input>
                              }@else {
                                <app-search
                                  [resource]="'CONTACT'"
                                  [label]="'Truck Shop'"
                                  [isReadOnly]="!EDIT_VIEW"
                                  [idInfo]="'claim-first'"
                                  [options]="{noFocus: true}"
                                  [method]="'search'"
                                  [filter]="{type: 'TRUCK SHOP', limit: 25, sort: 'quoteCount', dir: 'desc', active: true, isAccount: true}"
                                  (onChange)="setShop('shopsFirst', $event)"
                                ></app-search>
                              }

                            </div>
                          </div>
                        }
                      </div>
                      <div class="estimates-item"
                      [ngClass]="{
                        'estimates-item-view py-2 px-2 rounded-lg': !EDIT_VIEW,
                        'active_estimate': claim?.estimates?.shopsMiddle?.isLowestQuote && !EDIT_VIEW,
                        'not_active_estimate': !claim?.estimates?.shopsMiddle?.isLowestQuote && !EDIT_VIEW && lowestQuote && lowestQuote !== ''
                      }">
                        @if(EDIT_VIEW){
                          <div [title]="!claim?.estimates?.shopsMiddle?.price ? 'Please enter price' : ''">
                            <app-btn-toggle
                              [idInfo]="'shopsMiddle'"
                              [checkbox]="true"
                              [disabled]="!claim?.estimates?.shopsMiddle?.price || !EDIT_VIEW"
                              [value]="$safeNavigationMigration(claim?.estimates?.shopsMiddle?.isLowestQuote)"
                              (onToggle)="setActiveShopId('shopsMiddle', $event)"
                            ></app-btn-toggle>
                          </div>
                        }
                        <span class="estimates-number act_it">2.</span>
                        @if(!EDIT_VIEW){
                          <div class="flex items-center"><i class="fa-solid fa-dollar-sign icon_currency act_it_icon"></i><span class="font-bold claim_estimates_view act_it">{{(claim?.estimates?.shopsMiddle?.price || 000) | myCurrency}}</span></div>
                          <p class="claim_estimates_view font-bold act_it">{{claim?.estimates?.shopsMiddle?.shop?.name}}</p>
                        }@else {
                          <div class="flex items-center flex-1">
                            <div class="estimates-pay">
                              <app-price
                                [value]="claim?.estimates?.shopsMiddle?.price || ''"
                                [icon]="'fa-solid fa-dollar-sign'"
                                [isReadOnly]="!EDIT_VIEW"
                                [options]="{iconCurrency: true}"
                                (onSave)="setShopPrice('shopsMiddle', $event)"
                              ></app-price>
                            </div>
                            <div class="estimates-shop">
                              @if(claim?.estimates?.shopsMiddle?.shop?._id){
                                <app-input
                                  [idInfo]="'middle'"
                                  [label]="'Truck Shop'"
                                  [isReadOnly]="!EDIT_VIEW"
                                  [value]="$safeNavigationMigration(claim?.estimates?.shopsMiddle?.shop?.name)"
                                  [options]="{canRemove: EDIT_VIEW}"
                                  (onRemove)="deleteShop('shopsMiddle')"
                                ></app-input>
                              }@else {
                                <app-search
                                  [resource]="'CONTACT'"
                                  [label]="'Truck Shop'"
                                  [isReadOnly]="!EDIT_VIEW"
                                  [idInfo]="'truck-shop-middle'"
                                  [options]="{noFocus: true}"
                                  [method]="'search'"
                                  [filter]="{type: 'TRUCK SHOP', limit: 25, sort: 'quoteCount', dir: 'desc', active: true, isAccount: true}"
                                  (onChange)="setShop('shopsMiddle', $event)"
                                ></app-search>
                              }
                            </div>
                          </div>
                        }
                      </div>
                      <div class="estimates-item"
                      [ngClass]="{
                        'estimates-item-view py-2 px-2 rounded-lg': !EDIT_VIEW,
                        'active_estimate': claim?.estimates?.shopsLast?.isLowestQuote && !EDIT_VIEW,
                        'not_active_estimate': !claim?.estimates?.shopsLast?.isLowestQuote && !EDIT_VIEW && lowestQuote && lowestQuote !== ''
                      }">
                      @if(EDIT_VIEW){
                        <div [title]="!claim?.estimates?.shopsLast?.price ? 'Please enter price' : ''">
                          <app-btn-toggle
                            [idInfo]="'shopsLast'"
                            [checkbox]="true"
                            [disabled]="!claim?.estimates?.shopsLast?.price || !EDIT_VIEW"
                            [value]="$safeNavigationMigration(claim?.estimates?.shopsLast?.isLowestQuote)"
                            (onToggle)="setActiveShopId('shopsLast', $event)"
                          ></app-btn-toggle>
                        </div>
                      }
                        <span class="estimates-number act_it">3.</span>
                        @if(!EDIT_VIEW){
                          <div class="flex items-center"><i class="fa-solid fa-dollar-sign icon_currency act_it_icon"></i><span class="font-bold claim_estimates_view act_it">{{(claim?.estimates?.shopsLast?.price || 000) | myCurrency}}</span></div>
                          <p class="claim_estimates_view font-bold act_it">{{claim?.estimates?.shopsLast?.shop?.name}}</p>
                        }@else {
                          <div class="flex items-center flex-1">
                            <div class="estimates-pay">
                              <app-price
                                [value]="claim?.estimates?.shopsLast?.price || ''"
                                [icon]="'fa-solid fa-dollar-sign'"
                                [isReadOnly]="!EDIT_VIEW"
                                [options]="{iconCurrency: true}"
                                (onSave)="setShopPrice('shopsLast', $event)"
                              ></app-price>
                            </div>
                            <div class="estimates-shop">
                              @if(claim?.estimates?.shopsLast?.shop?._id){
                                <app-input
                                  [idInfo]="'last'"
                                  [label]="'Truck Shop'"
                                  [isReadOnly]="!EDIT_VIEW"
                                  [value]="$safeNavigationMigration(claim?.estimates?.shopsLast?.shop?.name)"
                                  [options]="{canRemove: EDIT_VIEW}"
                                  (onRemove)="deleteShop('shopsLast')"
                                ></app-input>
                              }@else {
                                <app-search
                                  [resource]="'CONTACT'"
                                  [label]="'Truck Shop'"
                                  [isReadOnly]="!EDIT_VIEW"
                                  [idInfo]="'truck-shop-middle'"
                                  [options]="{noFocus: true}"
                                  [method]="'search'"
                                  [filter]="{type: 'TRUCK SHOP', limit: 25, sort: 'quoteCount', dir: 'desc', active: true, isAccount: true}"
                                  (onChange)="setShop('shopsLast', $event)"
                                ></app-search>
                              }

                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="charges-container claim_info_item claim-cont-item">
          <div class="">
            <div class="flex items-center">
              <p class="item_det-title">Charges</p>
              <span class="updated-date-charges">
                Updated at {{claim?.amounts?.charges?.updatesDate && claim?.amounts?.charges?.updatesDate !== '' ? ($safeNavigationMigration(claim?.amounts?.charges?.updatesDate) | date: 'MM/dd/yyy h:m a') : ($safeNavigationMigration(claim?.createdAt) | date: 'MM/dd/yyy h:m a')}}
              </span>
            </div>


            <div class="charges_list">
              <!-- <div class="claim-payd_item" [ngClass]="{'flex items-center justify-between border-b border-gray-200 pb-3': !EDIT_VIEW}">
                <p class="claim_info-title">How Much Was Paid</p>
                <div class="flex items-center claim_pay_view" *ngIf="!EDIT_VIEW"><i class="fa-solid fa-dollar-sign icon_currency"></i><span>{{claim?.realPaidAmount | myCurrency}}</span></div>
                <app-price
                  *ngIf="EDIT_VIEW"
                  [isReadOnly]="locked || isReadOnly || !EDIT_VIEW"
                  [type]="'price'"
                  [title]="'claim?.realPaidAmount'"
                  [value]="claim?.realPaidAmount"
                  [icon]="'fa-solid fa-dollar-sign'"
                  [options]="{iconCurrency: true}"
                  (onSave)="patchClaim({ realPaidAmount: $event })"
                ></app-price>
              </div> -->


              <div class="charges_item flex items-center justify-between">
                <span class="charges_title">Settlement:</span>
                <div class="prive-charges-wr">
                  @if(EDIT_VIEW){
                    <app-price
                      [isReadOnly]="locked || isReadOnly || !EDIT_VIEW"
                      [value]="$safeNavigationMigration(claim.amounts?.charges?.settlement)"
                      [icon]="'fa-solid fa-dollar-sign'"
                      [options]="{iconCurrency: true}"
                      (onSave)="patchClaimCharges({ 'amounts.charges.settlement': $event == '' ? 0 : $event })"
                    ></app-price>
                  }@else {
                    <div class="flex items-center claim_pay_view"><i class="fa-solid fa-dollar-sign icon_currency"></i><span class="font-bold">{{$safeNavigationMigration(claim.amounts?.charges?.settlement) | myCurrency}}</span></div>
                  }
                </div>
              </div>
              <div class="charges_item flex items-center justify-between">
                <span class="charges_title">Admin Fee:</span>
                <div class="prive-charges-wr">
                  @if(EDIT_VIEW){
                    <app-price
                      [isReadOnly]="locked || isReadOnly || !EDIT_VIEW"
                      [value]="$safeNavigationMigration(claim.amounts?.charges?.adminFee)"
                      [icon]="'fa-solid fa-dollar-sign'"
                      [options]="{iconCurrency: true}"
                      (onSave)="patchClaimCharges({ 'amounts.charges.adminFee': $event == '' ? 0 : $event })"
                    ></app-price>
                  }@else {
                    <div class="flex items-center claim_pay_view"><i class="fa-solid fa-dollar-sign icon_currency"></i><span class="font-bold">{{$safeNavigationMigration(claim.amounts?.charges?.adminFee) | myCurrency}}</span></div>
                  }
                </div>
              </div>
              <div class="charges_item flex items-center justify-between">
                <span class="charges_title">Company Charge:</span>
                <div class="prive-charges-wr">
                  @if(EDIT_VIEW){
                    <app-price
                      [isReadOnly]="locked || isReadOnly || !EDIT_VIEW"
                      [value]="$safeNavigationMigration(claim.amounts?.charges?.company)"
                      [icon]="'fa-solid fa-dollar-sign'"
                      [options]="{iconCurrency: true}"
                      (onSave)="patchClaimCharges({ 'amounts.charges.company': $event == '' ? 0 : $event })"
                    ></app-price>
                  }@else {
                    <div class="flex items-center claim_pay_view"><i class="fa-solid fa-dollar-sign icon_currency"></i><span class="font-bold">{{$safeNavigationMigration(claim.amounts?.charges?.company) | myCurrency}}</span></div>
                  }
                </div>
              </div>
              <div class="charges_item flex items-center justify-between">
                <span class="charges_title">Total Drivers Charge:</span>
                <div class="prive-charges-wr">
                  @if(EDIT_VIEW){
                    <app-price
                      [isReadOnly]="locked || isReadOnly || !EDIT_VIEW"
                      [value]="$safeNavigationMigration(claim.amounts?.charges?.driver)"
                      [icon]="'fa-solid fa-dollar-sign'"
                      [options]="{iconCurrency: true}"
                      (onSave)="patchClaimCharges({ 'amounts.charges.driver': $event == '' ? 0 : $event })"
                    ></app-price>
                  }@else {
                    <div class="flex items-center claim_pay_view"><i class="fa-solid fa-dollar-sign icon_currency"></i><span class="font-bold">{{$safeNavigationMigration(claim.amounts?.charges?.driver) | myCurrency}}</span></div>
                  }
                </div>
              </div>
              @for(driverId of claim.driversFault; track $index){
                <div class="amounts_item-driver">
                  @let _driverFee = (claim.amounts?.charges?.drivers
                  ? $safeNavigationMigration(claim.amounts?.charges?.drivers[driverId])
                  : 0);
                  <div class="flex flex-col gap-2">
                    <div class="amounts_item flex items-center justify-between">
                      <div class="flex items-center">
                        <span class="amounts_title">{{$safeNavigationMigration(getContactById(driverId)?.type) | titlecase}}:</span>
                        <span class="amounts_value">{{getContactById(driverId)?.name}}</span>
                      </div>
                      <div class="prive-charges-wr">
                        @if(EDIT_VIEW){
                          <app-price
                            [isReadOnly]="locked || isReadOnly || !EDIT_VIEW"
                            [value]="_driverFee"
                            [icon]="'fa-solid fa-dollar-sign'"
                            [options]="{iconCurrency: true}"
                            (onSave)="patchDriverChargesAmount(driverId, $event)"
                          ></app-price>
                        }@else {
                          <div class="flex items-center claim_pay_view"><i class="fa-solid fa-dollar-sign icon_currency"></i><span class="font-bold">{{_driverFee | myCurrency}}</span></div>
                        }
                      </div>
                    </div>

                    <div class="claim-deductions">
                      @let driver = getContactById(driverId);
                      @if(driver?._contactBuckets?.length){
                        <div class="flex flex-col w-full gap-1">
                          <div class="items-center flex gap-[10px]">
                            <div class="text-sm">
                              Deductions
                            </div>
                            @let totalDecutionsFromBucketBuckets = getTotalDecutionsFromBuckets(driverId, 'SPEND');
                            <span class="font-semibold whitespace-nowrap">
                              Bucket: ${{totalDecutionsFromBucketBuckets || 0 | myCurrency}}
                            </span>
                            @let totalDecutionsFromTripBuckets = getTotalDecutionsFromBuckets(driverId, 'TRANSFER');
                            <span class="font-semibold whitespace-nowrap">
                              Trips: ${{totalDecutionsFromTripBuckets || 0 | myCurrency}}
                            </span>
                          </div>
                          <div class="flex flex-col gap-[2px]">
                            @for(bucket of driver?._contactBuckets; track bucket._id){
                              <div class="flex items-center justify-between gap-[10px]">
                                <span class="text-sm">#{{bucket.depositNumber}}</span>
                                <span class="text-sm">
                                  @if(bucket.type === 'SPEND'){
                                    #{{bucket.depositNumber}}
                                  }@else if(bucket.type === 'TRANSFER') {
                                    <i class="fa-solid fa-road text-gray-500 mr-1 text-[12px]"></i>
                                    <a [routerLink]="['/', userIndex, 'trips', bucket.resourceId]" target="_blank">{{bucket.resourceName}}</a>
                                  }
                                </span>
                                <div class="prive-charges-wr">
                                  <div class="flex items-center claim_pay_view">
                                    <span class="font-medium text-red-600 text-sm">- ${{bucket.amount | myCurrency}}</span>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                    @let contactDepositAmountOfDriver = getContactDepositForDriver(driverId);
                    @if(contactDepositAmountOfDriver && contactDepositAmountOfDriver > 0){
                      @let leftToCharge = _driverFee - contactDepositAmountOfDriver;
                      <div class="flex items-center justify-between mb-2">
                        <span class="charges_title text-sm">Left to Charge:</span>
                        <div class="prive-charges-wr">
                          <div class="flex items-center claim_pay_view">
                            <span class="font-medium text-base" [ngClass]="{'text-green-600': leftToCharge <= 0, 'text-red-600': leftToCharge > 0}">${{leftToCharge | myCurrency}}</span>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
            <div class="driverNotified">
              <app-btn-toggle
                [checkbox]="true"
                [disabled]="locked || isReadOnly || !EDIT_VIEW"
                [value]="$safeNavigationMigration(claim?.driverNotified)"
                [label]="'Driver Notified Of Deduction'"
                (onToggle)="patchClaim({ driverNotified: $event })"
              >
              </app-btn-toggle>
            </div>
          </div>
          <div class="claim__amounts-container">
            <div class="flex items-center">
              <p class="item_det-title">Settlement</p>
              @if(totalOfResponsibleMinusSettlement){
                <span class="settlement_warning">settlement does't match</span>
              }
            </div>

            <div class="amounts_list_wrapper">
              <div class="amounts_list" [ngClass]="{'border-none': !claim.amounts?.responsible?.admin}">
                @for(driverId of claim.driversFault; track $index){
                  <div class="amounts_item-driver">
                    @let _driverFee = (claim.amounts?.responsible?.drivers
                    ? $safeNavigationMigration(claim.amounts?.responsible?.drivers[driverId])
                    : 0);
                    <div class="amounts_item flex items-center justify-between">
                      <div class="flex items-center">
                        <span class="amounts_title">{{$safeNavigationMigration(getContactById(driverId)?.type) | titlecase}}:</span>
                        <span class="amounts_value">{{getContactById(driverId)?.name}}</span>
                      </div>
                      <div class="prive-charges-wr">
                        @if(EDIT_VIEW){
                          <app-price
                            [isReadOnly]="locked || isReadOnly || !EDIT_VIEW"
                            [value]="_driverFee"
                            [icon]="'fa-solid fa-dollar-sign'"
                            [options]="{iconCurrency: true}"
                            (onSave)="patchDriverResponsibleAmount(driverId, $event)"
                          ></app-price>
                        }@else {
                          <div class="flex items-center claim_pay_view"><i class="fa-solid fa-dollar-sign icon_currency"></i><span class="font-bold">{{_driverFee | myCurrency}}</span></div>
                        }
                      </div>
                    </div>
                  </div>
                }
                @if(claim?.carrierAtFault){
                  <div class="amounts_item flex items-center justify-between">
                    <div class="flex items-center">
                      <span class="amounts_title">Carrier:</span>
                      <span class="amounts_value">{{getContactById(carrierId)?.name}}</span>
                    </div>
                    <div class="prive-charges-wr">
                      @if(EDIT_VIEW){
                        <app-price
                          [isReadOnly]="locked || isReadOnly || !EDIT_VIEW"
                          [value]="$safeNavigationMigration(claim.amounts?.responsible?.carrier)"
                          [icon]="'fa-solid fa-dollar-sign'"
                          [options]="{iconCurrency: true}"
                          (onSave)="patchClaim({ 'amounts.responsible.carrier': $event })"
                        ></app-price>
                      }@else {
                        <div class="flex items-center claim_pay_view"><i class="fa-solid fa-dollar-sign icon_currency"></i><span class="font-bold">{{$safeNavigationMigration(claim.amounts?.responsible?.carrier) | myCurrency}}</span></div>
                      }
                    </div>
                  </div>
                }
                @if(claim.driversFault?.length){
                  <div class="amounts_item flex items-center justify-between">
                    <div class="flex items-center">
                      <span class="amounts_title">Admin:</span>
                      <span class="amounts_value">{{getContactById(carrierId)?.name}}</span>
                    </div>
                    <div class="prive-charges-wr">
                      @if(EDIT_VIEW){
                        <app-price
                          [isReadOnly]="locked || isReadOnly || !EDIT_VIEW"
                          [value]="$safeNavigationMigration(claim.amounts?.responsible?.admin)"
                          [icon]="'fa-solid fa-dollar-sign'"
                          [options]="{iconCurrency: true}"
                          (onSave)="patchClaim({ 'amounts.responsible.admin': $event })"
                        ></app-price>
                      }@else {
                        <div class="flex items-center claim_pay_view"><i class="fa-solid fa-dollar-sign icon_currency"></i><span class="font-bold">{{$safeNavigationMigration(claim.amounts?.responsible?.admin) | myCurrency}}</span></div>
                      }
                    </div>
                  </div>
                }
                @if(claim?.dispatcherAtFault){
                  <div class="amounts_item flex items-center justify-between">
                    <div class="flex items-center">
                      <span class="amounts_title">Dispatcher:</span>
                      @if(claim?.dispatchersAtFault?.length){
                        <span class="amounts_value">{{getContactById($safeNavigationMigration(claim?.dispatchersAtFault[0]))?.name}}</span>
                      }
                    </div>
                    <div class="prive-charges-wr">
                      @if(EDIT_VIEW){
                        <app-price
                          [isReadOnly]="locked || isReadOnly || !EDIT_VIEW"
                          [value]="$safeNavigationMigration(claim.amounts?.responsible?.dispatcher)"
                          [icon]="'fa-solid fa-dollar-sign'"
                          [options]="{iconCurrency: true}"
                          (onSave)="patchClaim({ 'amounts.responsible.dispatcher': $event })"
                        >
                        </app-price>
                      }@else {
                        <div class="flex items-center claim_pay_view"><i class="fa-solid fa-dollar-sign icon_currency"></i><span class="font-bold">{{$safeNavigationMigration(claim.amounts?.responsible?.dispatcher) | myCurrency}}</span></div>
                      }
                    </div>
                  </div>
                }
                <div class="amounts_item flex items-center justify-between">
                  <span class="amounts_title">Insurance:</span>
                  <div class="prive-charges-wr">
                    @if(EDIT_VIEW){
                      <app-price
                        [isReadOnly]="locked || isReadOnly || !EDIT_VIEW"
                        [value]="$safeNavigationMigration(claim.amounts?.responsible?.insurance)"
                        [icon]="'fa-solid fa-dollar-sign'"
                        [options]="{iconCurrency: true}"
                        (onSave)="patchClaim({ 'amounts.responsible.insurance': $event })"
                      ></app-price>
                    }@else {
                      <div class="flex items-center claim_pay_view"><i class="fa-solid fa-dollar-sign icon_currency"></i><span class="font-bold">{{$safeNavigationMigration(claim.amounts?.responsible?.insurance) | myCurrency}}</span></div>
                    }
                  </div>
                </div>
              </div>
              @for(driverId of claim.driversFault; track $index) {
                <div>
                  @let driverFee = (claim.amounts?.responsible?.drivers
                    ? $safeNavigationMigration(claim.amounts?.responsible?.drivers[driverId])
                    : 0);
                  @if(claim.amounts?.responsible?.admin) {
                    <div class="settlement_total flex items-center justify-between">
                      <span class="amounts_title">Total:</span>
                      <span class="amounts_value">USD ${{ trunc((driverFee + claim.amounts?.responsible?.admin /
                        claim.driversFault?.length).tf2) | myCurrency }}</span>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
          <div class="claim_payment-wr">
            <p class="item_det-title">Payment</p>
            <div class="claim_payment-container">
              <div class="amounts_item flex items-center justify-between">
                <span class="amounts_title paym-title">Name:</span>
                <div class="payment-container-value">
                  @if(EDIT_VIEW){
                    <app-input
                      [isReadOnly]="locked || isReadOnly || !EDIT_VIEW"
                      [title]="'claim?.payment?.name'"
                      [value]="$safeNavigationMigration(claim?.payment?.name)"
                      [label]="'Name'"
                      [type]="'text'"
                      (onSave)="claim.payment = claim.payment || {}; claim.payment.name = $event; patchClaim({ payment: $safeNavigationMigration(claim?.payment) })"
                    ></app-input>
                  }@else {
                    <p class="amounts_value">{{claim?.payment?.name}}</p>
                  }
                </div>
              </div>
              <div class="amounts_item flex items-center justify-between">
                <span class="amounts_title paym-title">Method:</span>
                <div class="payment-container-value">
                  @if(EDIT_VIEW){
                    <app-select
                      [isReadOnly]="!EDIT_VIEW"
                      (onSave)="claim.payment.method = $event; patchClaim({ payment: $safeNavigationMigration(claim?.payment) })"
                      [value]="$safeNavigationMigration(claim?.payment?.method)"
                      [list]="paymentMethods"
                      [label]="'Method:'"
                      [placeholder]="'Select Method'"
                      [idInfo]="'claim-paymentMethods'"
                    ></app-select>
                  }@else {
                    <p class="amounts_value">{{claim?.payment?.method}}</p>
                  }
                </div>
              </div>
              <div class="amounts_item flex items-center justify-between">
                <span class="amounts_title paym-title">Address:</span>
                <div class="payment-container-value">
                  @if(EDIT_VIEW){
                    <app-address
                    [isReadOnly]="locked || isReadOnly || !EDIT_VIEW"
                    [title]="'claim?.payment?.address'"
                    [address]="$safeNavigationMigration(claim?.payment?.address)"
                    [options]="{usInput: true}"
                    [label]="'Address'"
                    [type]="'address'"
                    (onSave)="claim.payment = claim.payment || {};
                        claim.payment.address = $event;
                        patchClaim({ payment: $safeNavigationMigration(claim?.payment) })"
                    >
                  </app-address>
                  }@else {
                    <p class="amounts_value">{{getAddress($safeNavigationMigration(claim?.payment?.address))}}</p>
                  }
                </div>
              </div>
              <div class="mt-3">
                <div class="item-notes relative" [ngClass]="{'bg-gray-50 rounded-lg border border-gray-300 p-2.5': EDIT_VIEW}">
                  <p [ngClass]="[EDIT_VIEW ? 'item-notes-title' : 'item_det-title']">Payment Notes</p>
                  <textarea rows="4" [disabled]="!EDIT_VIEW" [value]="claim?.payment?.notes ? $safeNavigationMigration(claim?.payment?.notes) : ''" (blur)="updatePaymentNote($any($event.target).value)" class="block w-full damage-notes-text text-sm p-0 text-gray-900 border-none focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="Type here"
                    [ngClass]="{'edit_textarea_notes': EDIT_VIEW}"
                  ></textarea>
                  @if(claim?.payment?.notes?.length){
                    <button class="item-notes-btn" [popper]="paymentNotes" [popperDisableStyle]="true" [popperPlacement]="NgxPopperjsPlacements.TOP" [popperTrigger]="NgxPopperjsTriggers.click" [popperHideOnClickOutside]="true">
                      <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
                    </button>
                  }
                  <popper-content #paymentNotes class="z-50">
                    <div class="rounded-lg bg-white item-notes-popover-wr">
                      <div class="bg-white rounded-lg">
                        <div class="relative">
                          <div class="flex items-center justify-between">
                            <span class="item-notes-title-popover">Payment Notes</span>
                            <button class="item-notes-close" (click)="paymentNotes.hide()">
                              <i class="fas fa-close text-gray-400"></i>
                            </button>
                          </div>
                          <textarea [disabled]="!EDIT_VIEW"
                            (blur)="updatePaymentNote($any($event.target).value)"
                            class="block w-full p-0 item-notes-popover-text bg-white rounded-lg border-none dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                            placeholder="Type here"
                          >{{claim?.payment?.notes ? claim?.payment?.notes : ''}}</textarea>
                        </div>
                      </div>
                    </div>
                  </popper-content>
                </div>
                <!-- <app-notes
                  [isReadOnly]="locked || isReadOnly"
                  [options]="{ list: true }"
                  [quoteId]="claim?._id"
                  [title]="'Payment Notes'"
                  [display]="{
                    tabs: { notes: true },
                    select: {
                      assignee: true,
                      visibility: true,
                      date: true,
                      typeTask: true,
                      complete: true,
                      title: 'Payment Notes'
                    }
                  }"
                  [creator]="currentUser"
                  [notes]="claim?.payment?.notes"
                  [usersEntities]="users"
                  (onCreate)="createNote('payment.notes', $event)"
                  (onUpdate)="updateNote('payment.notes', $event)"
                  (onRemove)="removeNote('payment.notes', $event)"></app-notes> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="claim-footer">
        <div class="claim-footer-left">
          <div class="claim_info_item claim-cont-item w-full relative">
            @if(newDocument){
              <div class="modal" (click)="newDocument = false"></div>
            }
            <div class="flex font-poppins claim-footer-menu">
              <span [ngClass]="[claimPage == 'notes' ? 'active-link-claim' : 'nav-link-claim']" (click)="claimPage = 'notes'">Notes</span>
              <span [ngClass]="[claimPage == 'tasks' ? 'active-link-claim' : 'nav-link-claim']" (click)="claimPage = 'tasks'">Tasks</span>
              <span *appHasPermission="'notifications_read'" [ngClass]="[claimPage == 'sentNotifications' ? 'active-link-claim' : 'nav-link-claim']" (click)="claimPage = 'sentNotifications'">Sent Notifications</span>
            </div>
            @if(!showHistory){
              <div class="pages-cont">
                @switch(claimPage){
                  @case ('notes') {
                    <div>
                      <app-notes
                        [isReadOnly]="locked || isReadOnly" [options]="{ list: true }"
                        [quoteId]="$safeNavigationMigration(claim?._id)"
                        [display]="{
                          tabs: { notes: true },
                          select: {
                            assignee: true,
                            visibility: true,
                            date: true,
                            typeTask: true,
                            complete: true
                          }
                        }" [creator]="currentUser" [usersEntities]="users"
                        [resource]="'CLAIM'"
                        [resourceId]="$safeNavigationMigration(claim?._id)"
                        ></app-notes>
                      <!--end:: Widgets/Notes -->
                    </div>
                  }
                  @case ('tasks') {
                    <div>
                      <app-tasks-container
                        [currentUser]="currentUser"
                        [resource]="{
                        resource: FOLLOW_UP_RESOURCE.CLAIM,
                        resourceId: claim._id,
                        resourceName: $safeNavigationMigration(claim?.autoIncr)+''
                      }"
                      ></app-tasks-container>
                    </div>
                  }
                  @case ('sentNotifications') {
                    <div>
                      <div *appHasPermission="'notifications_read'">
                        <app-send-notifications [notifications]="notifications"></app-send-notifications>
                      </div>
                    </div>
                  }
                }

                <!--

                  ?????

                -->
                <!-- <div class="col-md-7">
                  <div class="p-3 d-flex">
                    <div class="w-50">
                      <app-diesel-chat STORE_NAME="CORE"
                        [options]="{ style: { height: '300px' }, edit: true, delete: true, create: true, archive: true }"
                        [currentUser]="currentUser" [resource]="FOLLOW_UP_RESOURCE.CLAIM" [resourceId]="claim._id" [resourceName]="claim?.autoIncr+''">
                      </app-diesel-chat>
                    </div>
                  </div>
                </div> -->
                <!--

                  ?????

                -->
              </div>
            }
          </div>
        </div>
        <div class="claim-footer-right">
          <div class="claim_info_item claim-cont-item flex flex-col justify-between">
            @if(newDocument){
              <div class="documents-edit-wr" (click)="$event.stopPropagation()">
                <div class="flex items-center justify-between">
                  <p class="plus-type-title">Checklist</p>
                </div>
                <div class="checklist_search flex items-center">
                  <input type="text" id="checklist_search" [(ngModel)]="documentType" class="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
                  <button class="check-type" (click)="addDocumentType()">
                    <i class="fa-solid fa-check"></i>
                  </button>
                </div>
                <div class="checklist_documents-edit">
                  @for(type of claim.checklist; track $index){
                    <div class="checklist-item-edit flex items-center justify-between">
                      <div class="flex items-center">
                        <input
                          class="custom-checkbox w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded"
                          type="checkbox"
                          [attr.disabled]="locked || isReadOnly"
                          [(ngModel)]="type.completed"
                          (click)="addActiveDocument(type)"
                          placeholder="Enter Text"
                          id="`document {{ type.name }}`"
                        />
                        <span>{{ type.name }}</span>
                      </div>
                      @if(!(locked || isReadOnly)){
                        <div class="ml-2">
                          <app-btn-confirm
                            (onConfirm)="removeChecklistItem(type)"
                          >
                          </app-btn-confirm>
                        </div>
                      }
                    </div>
                  }
                </div>
              </div>
            }@else {
              <div>
                <div>
                  <p class="item_det-title">Documents Checklist</p>
                  <div class="checklist_documents">
                    @for(type of claim.checklist; track $index){
                      <div class="checklist-item flex items-center">
                        <input
                          class="custom-checkbox w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded"
                          type="checkbox"
                          [attr.disabled]="locked || isReadOnly"
                          [disabled]="locked || isReadOnly"
                          [(ngModel)]="type.completed"
                          (click)="addActiveDocument(type)"
                          placeholder="Enter Text"
                          id="`document {{ type.name }}`"
                        />
                        <span>{{ type.name | titlecase }}</span>
                      </div>
                    }
                  </div>
                </div>
                @if(!(locked || isReadOnly)){
                  <div>
                    <button class="add-new-type" (click)="newDocument = !newDocument">
                      + Add New Type
                    </button>
                  </div>
                }
              </div>
            }
          </div>
          <div class="claim_info_item claim-cont-item relative">
            @if(newDocument){
              <div class="modal" (click)="newDocument = false"></div>
            }
            <div class="font-medium text-center text-gray-500 mb-4">
              <div class="flex font-poppins claim-footer-menu">
                <span [ngClass]="[fileView == 'claim' ? 'active-link-claim' : 'nav-link-claim']" (click)="fileView = 'claim'">Files</span>
                @if(order?._id){
                  <span [ngClass]="[fileView == 'order' ? 'active-link-claim' : 'nav-link-claim']" class="ml-2" (click)="fileView = 'order'">Order Files</span>
                }
                @if(claim?._local?.expense?._id){
                  <span [ngClass]="[fileView == 'expense' ? 'active-link-claim' : 'nav-link-claim']" class="ml-2" (click)="fileView = 'expense'">Expense Files</span>
                }
              </div>
            </div>
            @if(fileView == 'claim'){
              <div>
                <app-files
                  [isReadOnly]="locked || isReadOnly"
                  [resource]="FOLLOW_UP_RESOURCE.CLAIM"
                  [resourceId]="$safeNavigationMigration(claim?._id)"
                  [lock]="locked"
                  (onSend)="sendFiles($event)"
                  [idInfo]="'clain-files'"
                ></app-files>
              </div>
            }@else if(order?._id && fileView == 'order'){
              <div>
                <app-files
                  [title]="'Order files'"
                  [isReadOnly]="true"
                  [resource]="FOLLOW_UP_RESOURCE.ORDER"
                  [resourceId]="$safeNavigationMigration(order?._id)"
                  [options]="{ showSelection: false }"
                  [idInfo]="'order-files'"
                  [lock]="locked"
                ></app-files>
              </div>
            }@else if(claim?._local?.expense?._id && fileView == 'expense'){
              <div>
                <app-files
                  [title]="'Expense files'"
                  [isReadOnly]="true"
                  [resource]="FOLLOW_UP_RESOURCE.EXPENSE"
                  [resourceId]="$safeNavigationMigration(claim?._local?.expense?._id)"
                  [options]="{ showSelection: false }"
                  [lock]="locked"
                  [idInfo]="'expense-files'"
                ></app-files>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
  }
</div>

